import React, { useState, useCallback, useEffect, useMemo } from 'react'



import { TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Accordion,
    AccordionDetails,
    Typography,
    CircularProgress,
    Divider,
    FormControlLabel,
    Checkbox,
    FormHelperText,
    FormGroup,
    FormLabel,
    Card,
    CardHeader,
    CardContent,
    Radio,
    RadioGroup
} from '@material-ui/core'

import { Alert, Autocomplete } from '@material-ui/lab'

import { ListadoEstudiantesScreen } from './ListadoEstudiantesScreen'
import SendIcon from '@material-ui/icons/Send'
import CachedIcon from '@material-ui/icons/Cached'
import PlaceIcon from '@material-ui/icons/Place';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { FormatoScreen } from '../formato/FormatoScreen';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { useStyles, StyledAccordionSummary, AccordionEstSummary, StyledAccordionActions, StyledAccordionDetails } from './RegistroEstudianteStyle'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useSelector, useDispatch } from 'react-redux'
import { getRegionesBD, getProvinciasBD, getDistritosBD, getRegionesMuniBD, getProvinciasMuniBD, getDistritosMuniBD } from '../../redux/thunk/ubigeoThunk'
import { TextNumber } from '../../controls/TextNumber'
import { resetProvincias, resetDistritos, resetProvinciasMuni, resetDistritosMuni, resetRegiones } from '../../redux/actions/ubigeoActions'
import { getInstituciones, resetInstituciones } from '../../redux/actions/instEducativaActions'
import { getInstitucionesBD } from '../../redux/thunk/instEducativaThunk'
import { getMunicipalidades, resetMunicipalidades } from '../../redux/actions/municipalidadActions'
import { getMunicipalidadesBD } from '../../redux/thunk/municipalidadThunk'
import { updatePadre } from '../../redux/actions/padreActions'
import { Formik, Field, useFormikContext, useField } from 'formik'
import MuiTextField from '@material-ui/core/TextField';
import {
    AutocompleteRenderInputParams,
} from 'formik-material-ui-lab';
import ProfileSchema from './registroEstudianteProfile'
import { getPreguntasBD } from '../../redux/thunk/preguntaThunk'
import { getFormatosByTipoBD } from '../../redux/thunk/formatoThunk'

import { insertVeeduriaBD, download } from '../../redux/thunk/veeduriaThunk'
import { validarDNI, obtenerFormatos, obtenerFormatosCompletados} from '../../redux/thunk/estudianteThunk'
import { resetValidacion, updateDato } from "../../redux/actions/estudianteActions"
import { ConfirmControl } from '../../controls/Confirmacion'
import { Alerta } from '../../controls/Alerta'
import { useRef } from 'react'
import { Mensaje, MensajeExito } from '../../controls/Mensaje'
import { isBrowser } from "react-device-detect";
import * as moment from 'moment';
import 'moment/locale/es';
import { getTiposInstEduBD, getNacionalidadesBD } from '../../redux/thunk/parametroThunk'
import { AvatarControl } from '../formato/controles/Avatar'
import { MapControl } from '../formato/controles/Map'
import MapContainer from '../formato/controles/MapContainer'
import { setCoordenadas } from '../../redux/actions/coordenadasActions'

import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import { CloudDownload, MicNoneTwoTone } from '@material-ui/icons'



window.cierra = '0'
var decode = require('decode-html');
debugger
const { niveles, grados_primaria, grados_secundaria, secciones, generos } = require("../../data/params")

/*alert('ingresa0')*/



function SuccessDialogAndDownload(props) {
    debugger;
    const dispatch = useDispatch()
    const { onClose, value: valueProp, open, ...other } = props;
    const [value, setValue] = React.useState(valueProp);
    const radioGroupRef = React.useRef(null);

    React.useEffect(() => {
        if (!open) {
            setValue(valueProp);
        }
    }, [valueProp, open]);

    const handleEntering = () => {
        if (radioGroupRef.current != null) {
            radioGroupRef.current.focus();
        }
    };

    const handleDownload = (id) => {
        debugger
        dispatch( download( id ) )
        //open={close};
        // onClose();
    };


    const CerrarVentana = () => {
   
    // setexpandedFormato( false ) 
     window.location.reload();
     onClose();   

    /* dispatch( obtenerFormatos( { dni: props.dni,
								tipo_doc_hijo: props.tipo_doc_hijo,
								region: props.region,
								tipo_inst_edu: props.tipo_inst_edu,
								cargo: "007",
								inst_educativa: props.inst_educativa,
								lista_formato: formatos.listado } ) );*/
   
    
    };


    const [isOpen, setIsOpen] = useState(false);

    const openDialog = () => {
        setIsOpen(true);
    };

    const closeDialog = () => {
     /*   dispatch( obtenerFormatos( { dni: valueProp.dni,
            tipo_doc_hijo: valueProp.tipo_doc_hijo,
            region: valueProp.region,
            tipo_inst_edu: valueProp.tipo_inst_edu,
            cargo: '007',
            inst_educativa: valueProp.inst_educativa,
            lista_formato: valueProp.formatos.listado } ) )
      */     

           
                    onClose();


                            };


     // Roberto Velasquez 07-07-2025
     const [cerrarPopup, setcerrarPopup] = useState(true);

     const CierraPopup = () => {
        onClose();
        
     //   valueProp.setcerrarPopup(false);
        
    };
/*
    const Asigna = () => {
    setFieldValue("nombre", '0');
    onClose();
    };
*/
    return (
      
        <Dialog
            maxWidth="xs"
            onEntering={handleEntering}
            aria-labelledby="confirmation-dialog-title"
            open={open}
            {...other}
        >
            <DialogTitle id="confirmation-dialog-title">¡Registro Exitoso!</DialogTitle>
            <DialogContent dividers>
                <InputLabel style={{ fontSize: '18px', width: '100%', color: '#000', marginTop: '10px'}}>
                    ...Muchas gracias por participar de la veeduría virtual....
                </InputLabel>
                <InputLabel id="ie-label" style={{ fontSize: '18px', width: '100%', color: '#000', marginTop: '10px'}}>
                    { valueProp.formato }
                </InputLabel>
                <InputLabel id="ie-label" style={{ fontSize: '18px', width: '100%', textTransform: 'capitalize', color: '#000', marginTop: '10px'}}>
                { valueProp.nombres } 
                </InputLabel>
                <InputLabel id="ie-label" style={{ fontSize: '18px', width: '100%', color: '#000', marginTop: '10px'}}>
                    Nro Documento: { valueProp.documento }
                </InputLabel>
           

                {  

                    (localStorage.getItem('tipo_envio') == 1)
                    ?
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '30px'}}>
                            <Button  variant="contained" size="large" onClick={onClose} color="primary">
                                Cerrar..
                            </Button>
                            <Button variant="contained" size="large"
                            // onClick={handleDownload(valueProp.id)}
                            onClick={ e => {
                                dispatch( download( valueProp.id ) )
                            } }
                            color="secondary" startIcon={ <CloudDownload /> } >
                                Descargar constancia.
                            </Button>

                        </div>
                    :
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '30px'}}>
                            <Button variant="contained" size="large" img src="../../assets/images/marker.png"
                            // onClick={handleDownload(valueProp.id)}
                            onClick={ e => {
                                dispatch( download( valueProp.id ) )
                            } }
                            color="secondary" startIcon={ <CloudDownload /> } >
                                Descargar constancia...
                            </Button>

                            <Button variant="contained" startIcon={ <CloseIcon /> } size="large" onClick={CerrarVentana} color="primary"  >
                                Cerrar..
                            </Button>
                       
                           
                        </div>
                        
                          
                }
            </DialogContent>
            {/* <DialogActions>
                <Button autoFocus onClick={handleCancel} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleOk} color="primary">
                    Ok
                </Button>
            </DialogActions> */}
        </Dialog>

        
           
    ); 
}


{/* 
SuccessDialogAndDownload.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
}*/}
;

export const RegistroEstudianteScreen = () => {

    const classes = useStyles()

    const dispatch = useDispatch()
    const padre = useSelector( state => state.padre )
    const estudiante = useSelector( state => state.estudiante )
    const regiones = useSelector( state => state.regiones )
    const provincias = useSelector( state => state.provincias )
    const distritos = useSelector( state => state.distritos )
    const instituciones = useSelector( state => state.instituciones )
    const regionesMuni = useSelector( state => state.regionesMuni )
    const provinciasMuni = useSelector( state => state.provinciasMuni )
    const distritosMuni = useSelector( state => state.distritosMuni )
    const municipalidades = useSelector( state => state.municipalidades )
    const formatos = useSelector( state => state.formatos )
    const tipos_documento = useSelector( state => state.tipos_documento )
    const tipos_inst_edu = useSelector( state => state.tipos_inst_edu )    
 
    const nacionalidades = useSelector( state => state.nacionalidades )   
    let { isComplete, existe_observacion } = useSelector( state => state.pregunta )
    const veeduria = useSelector( state => state.veeduria )
    const [expandedHijo, setexpandedHijo] = useState(false)
    const [expandedIE, setexpandedIE] = useState(false)
    const [expandedMuni, setexpandedMuni] = useState(false)
    const [expandedFormato, setexpandedFormato] = useState(false)
    let { preguntas } = useSelector( state => state.pregunta )
    const informacion_basica = useSelector( state => state.informacion_basica )
    

    const scrollToAnchor = (anchorName) => {
        if (anchorName) {
            let anchorElement = document.getElementById(anchorName);
            if(anchorElement) { anchorElement.scrollIntoView(); }
        }
    }


    const [alert, setAlert] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: 'success'
    });
    const handleCloseAlert = () => {
        setAlert({ ...alert, open: false });
    };
    const messageActive = useRef( veeduria.message )



    useEffect(() => {
        if ( veeduria.message === 'ok' && veeduria.severity === 'success' )
        {
            const nombre_formato_vee = localStorage.getItem('nombre_formato_vee');

            if(informacion_basica.cargo == '007') {
                handleClickListItemX({ 
                    formato: nombre_formato_vee,
                    nombres: veeduria.estudiante.nombre + ' ' + veeduria.estudiante.apellido_paterno + ' ' + veeduria.estudiante.apellido_materno,
                    documento: veeduria.estudiante.dni,
                    id: veeduria.estudiante.id_veeduria
                });
                // Mensaje(`
                //     Muchas gracias por participar de la veeduría virtual
                //     <br>
                //     ${nombre_formato_vee}
                //     <br>
                //     <br>
                //     <span style="font-size: 20px; text-transform: capitalize;">${veeduria.nombre} ${veeduria.apellido_paterno} ${veeduria.apellido_materno}</span>
                //     <br>
                //     <span style="font-size: 20px">Nro. documento: ${veeduria.dni}</span>
                //     <br>
                // `, '¡Registro Exitoso!', 'success', localStorage.getItem('tipo_envio') == 1)
            }
            else {
                Mensaje(`
                    Muchas gracias por participar de la veeduría virtual..
                    <br>
                    ${nombre_formato_vee}
                    <br>
                    <br>
                    <span style="font-size: 20px; text-transform: capitalize;">${padre.nombre_completo}</span>
                    <br>
                    <span style="font-size: 20px">Nro. documento: ${padre.dni}</span>
                    <br>
                `, '¡Registro Exitoso!', 'success', false)
                
            }
            // setAlert({ ...alert, open: true, message: 'Se registró con éxito.', severity: veeduria.severity });
            messageActive.current = veeduria.message;
/*
            if (localStorage.getItem('tipo_envio') == 2) {
                setTimeout(() => {
                    handleReload();
                }, 50000);
            }
            else{
                setTimeout(() => {
                    veeduria.message = '';
                    bloquearFormato();
                }, 100);
            }*/
        }

    }, [ veeduria, alert ])

    useEffect( () => {
        if ( padre.severity === 'success' ) {
            setTimeout( () => {
                setexpandedHijo( true )
                setexpandedIE( true )
                setexpandedMuni( true )
                setexpandedFormato( true )
                dispatch( getFormatosByTipoBD(informacion_basica.cargo, informacion_basica.miembro) )
                dispatch( getTiposInstEduBD() )
                // dispatch( getPreguntasBD() )
            }, 500 );
        }
    }, [ padre.severity, dispatch ] )

    const MyField = props => {
        const {
            setFieldValue,
        } = useFormikContext();
        const [field, meta] = useField(props);
    
        useEffect(() => {
            let isCurrent = true;
            if ( estudiante.message?.length > 0 && estudiante.severity !== 'success' && !estudiante.isLoading ) {
                if (!!isCurrent) {
                    setFieldValue(props.name, '');
                }
            }

            return () => {
                isCurrent = false;
            };
        }, [ setFieldValue, props.name ]);
    
        useEffect(() => {
            if (meta.value.length === 8 && !estudiante.isLoading)
            {
                if (meta.value !== padre.dni) {
                    dispatch( validarDNI( { dni: meta.value, tipo_doc_hijo: estudiante.tipo_doc_hijo, lista_formato: formatos.listado } ) )
                    setFieldValue("nivel", '');
                    setFieldValue("grado", '');
                    setFieldValue("seccion", '');
                    setFieldValue("region", '');
                    setFieldValue("provincia", '')
                    setFieldValue("distrito", '')
                    setFieldValue('inst_educativa', '' );
                    setFieldValue('formato', '' );
                }
            }
        }, [ meta.value ]);

        return (
        <>
            <TextField  className={ classes.inputStyle} 
            fullWidth 
            size="small"
            label="Nro. documento"
            variant="outlined"
            autoComplete="off"
            onChange={ ( { target } ) => {
                setFieldValue( "dni", target.value )
            } }
            helperText={ meta.touched ? meta.error : ""}
            error={ meta.touched && Boolean( meta.error ) }
            InputProps={ { inputComponent: TextNumber } }
            disabled={ estudiante.isLoading }
            {...props}
            {...field}
            />
            { estudiante.isLoading && <CircularProgress size={ 20 } className={ classes.fieldProgress } /> }
            
        </>
        );


    };

    

    const bloquearFormato = () => {
        let arr_id_formato_registrados = [];
        if (localStorage.getItem('arr_id_formato_registrados') != null)
            arr_id_formato_registrados = JSON.parse(localStorage.getItem("arr_id_formato_registrados"));
        
        arr_id_formato_registrados.push(localStorage.getItem('id_formato_selected'));

        formatos.listado.forEach(element => {
            arr_id_formato_registrados.forEach(function (elemento, indice, array) {
                if (element.FORMATO_COD == elemento){
                    element.HABILITADO = false;
                    element.SELECTED = false;
                }
            });

           

        });

        localStorage.setItem('arr_id_formato_registrados', JSON.stringify(arr_id_formato_registrados));
        localStorage.removeItem('id_formato_selected');
    }


    const handleReload = () => {
        // history.push('/')
        // history.replace('/')

        localStorage.removeItem('tipo_envio');
        localStorage.removeItem('nombre_formato_vee');
        localStorage.removeItem('id_formato_selected');
        localStorage.removeItem('arr_id_formato_registrados');
        
        window.location.reload();
    }


    const [openResetForm, setOpenResetForm] = React.useState(false);

    const handleClickOpenResetForm = () => {
        setOpenResetForm(true);

        

    };
    
    const handleClickCloseResetForm = (newValue) => {
        setOpenResetForm(false);
    };

    const handleClickValidaForm = () => {
        return validaPreguntas();
    }



    const validaPreguntas = () => {

        let cantRespuestasVacias = 0;
        let preguntasSinRespuesta = [];
        let preguntasSinArchivo = [];
        let cabnombre = null;
        let cabappaterno = null;
        let cabapmaterno = null;
        let form_genero = null;
        let cabcorreo = null;
        let gradodiv = localStorage.getItem('gradodiv');
        let secciondiv = localStorage.getItem('secciondiv');
        let cabprofesor = null;
        let cabseccion = null;
        let cabgrado = null;

        let generodiv = localStorage.getItem('generodiv');
        
        let valordiv = localStorage.getItem('valordiv');

        console.log('generodiv 01 ', generodiv);

        const selectElement = document.getElementById("region");
      // const valorSeleccionado = selectElement.value;
        console.log('selectElement ', selectElement);
        console.log('valordiv 01 ', valordiv);

        /* ini */
        let reg = null;
        reg  = document.getElementById("region").value;
        //reg  = $('#region').val();

        console.log("region value", reg)
        /* fin */

        cabnombre = document.getElementById('cabnombre').value;
        
        console.log('cabnombre value', cabnombre)
      
         if (( cabnombre == null ) || ( cabnombre == "" )){
         Mensaje('Debe ingresar el nombre del estudiante', '¡Validación!', 'info')
         return false;
         }

         cabappaterno = document.getElementById('cabappaterno').value;
              
         if (( cabappaterno == null ) || ( cabappaterno == "" )){
         Mensaje('Debe ingresar el apellido paterno del estudiante', '¡Validación!', 'info')
         return false;
         }
       
        cabapmaterno = document.getElementById('cabapmaterno').value;
              
         if (( cabapmaterno == null ) || ( cabapmaterno == "" )){
         Mensaje('Debe ingresar el apellido materno del estudiante', '¡Validación!', 'info')
         return false;
         }
        
         if (( generodiv == null ) || ( generodiv == "" )){
         Mensaje('Debe ingresar el género del estudiante', '¡Validación!', 'info')
         return false;
         }

        /* 
         cabcorreo = document.getElementById('cabcorreo').value;
        
         console.log('cabcorreo 01', cabcorreo)

       if (( cabcorreo == null ) || ( cabcorreo == "" )){
         Mensaje('Debe ingresar el correo del estudiante', '¡Validación!', 'info')
         return false;
         }
         
           if (( secciondiv == null ) || ( secciondiv == "" )){
         Mensaje('Debe ingresar la sección del estudiante', '¡Validación!', 'info')
         return false;
         }*/


        
/*
         grado = document.getElementById('grado').value;
              
         if (( grado == null ) || ( grado == "" )){
         Mensaje('Debe ingresar el grado del estudiante', '¡Validación!', 'info')
         return false;
         }

        form_seccion = document.getElementById('form-seccion').value;
              
         if (( form_seccion == null ) || ( form_seccion == "" )){
         Mensaje('Debe ingresar la sección del estudiante', '¡Validación!', 'info')
         return false;
         }
*/
        cabprofesor = document.getElementById('cabprofesor').value;
              
         if (( cabprofesor == null ) || ( cabprofesor == "" )){
         Mensaje('Debe ingresar el profesor del estudiante', '¡Validación!', 'info')
         return false;
         }

         cabseccion = localStorage.getItem('secciondiv');
              
         if (( cabseccion == null ) || ( cabseccion == "" )){
         Mensaje('Debe ingresar la sección del estudiante', '¡Validación!', 'info')
         return false;
         }


         

         cabgrado = localStorage.getItem('gradodiv');
              
         if (( cabgrado == null ) || ( cabgrado == "" )){
         Mensaje('Debe ingresar el grado del estudiante', '¡Validación!', 'info')
         return false;
         }



        preguntas.forEach(preg => {
            if (preg.ID != 514 && preg.ID != 534 && preg.ID != 544 && preg.ID != 564)
            {
                if (preg.TIPO_RPTA_COD == 8 || preg.TIPO_RPTA_COD == 9){
                    if(preg.COORDENADAS == null || preg.COORDENADAS.length == 0 || preg.COORDENADAS[0].referencia.trim() == ''){
                        preguntasSinRespuesta.push(preg.CODIGO);
                        cantRespuestasVacias++;
                    }
                }
                else{
                    if (preg.RESPUESTA.length === 0 && preg.IND_PADRE.toString() === '0' && preg.HABILITADO)
                    {
                        preguntasSinRespuesta.push(preg.CODIGO);
                        cantRespuestasVacias++;
                    }
                    if (preg.ARCHIVO.length === 0 && preg.OBLIGATORIO_ARCHIVO === '1' && preg.UPLOAD)
                    {
                        preguntasSinArchivo.push(preg.CODIGO);
                    }
                }
            }
        });

        if ( cantRespuestasVacias === 0 )
        {
            return true;
        }
        else{
            let codigos = "";
            preguntasSinRespuesta.forEach(preg => {
                codigos += `
                    <span style="font-size: 20px; color: #b71c1c; font-weight: 700">${ preg }</span>
                    <br>
                `
            })

            Mensaje(`
                ${
                    preguntasSinRespuesta.length === 1
                    ? "Falta responder la pregunta:"
                    : "Falta responder las preguntas:"
                }
                <br>
                <br>
                ${ codigos }
            `, '¡Validación!', 'info')
            return false;
        }
    };


    
    const validaSeleccionFormato = () => {
        console.log('validaSeleccionFormato:::::', localStorage.getItem('id_formato_selected'))
        if ( localStorage.getItem('id_formato_selected') == null )
        {
            Mensaje('Debe seleccionar una veeduría', '¡Validación!', 'info')
            return false;
        }
        else {
            return true;
        }
    };



    const [openMap, setOpenMap] = React.useState(false);
    const [ubicacion, setUbicacion] = React.useState({ 'lat': 0, 'lng': 0 });
    const [referencia_mapa, setDireccion] = React.useState('');

    const handleClickOpenMap = () => {
        setOpenMap(true);
    };

    const handleCloseMap = () => {
        setOpenMap(false);
    };

    const handleGuardarPoint = (e, coor, direccion) => {
        console.log(coor)
        console.log('direccion: ', direccion);
        setUbicacion(coor);
        setDireccion(direccion);
        setOpenMap(false);
    };




    const [state, setState] = React.useState({
        checkedAUTORIZACION: false
    });
    
    const handleChangeAUTORIZACION = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };
    const [showMore, setShowMore] = useState(false);

    const toggleShowMore = () => {
        setShowMore(!showMore);
    };

   

    
    const [openX, setOpenX] = React.useState(false);
    const [valueX, setValueX] = React.useState({ 
        formato: '',
        nombres: '',
        documento: '',
        id: ''
    });

    const handleClickListItemX = (newValue) => {
        debugger;
        setOpenX(true);
        setValueX(newValue);
    };

    const handleCloseX = () => {
        setOpenX(false);
    };

    // Roberto Velasquez 07-07-2025
    const [cerrarPopup, setcerrarPopup] = useState(true);

    const CierraPopup = () => {
       setcerrarPopup(false);
      // onClose();
   };

   
    return (
        <Formik
        initialValues={ estudiante }
        validate={values => {
            let errors = {};
            
            if (values.dni.length === 8)
            {
                if (values.dni === padre.dni)
                {
                    errors.dni = 'No debe ser igual al documento del padre'
                }
            }
            return errors;
        }}
        validationSchema={ ProfileSchema }
        onSubmit={ ( values, { setSubmitting, resetForm } ) => {
            const payload = {
                tipo_doc_hijo: values.tipo_doc_hijo,
                nombre: values.nombre, 
                apellido_paterno: values.apellido_paterno, 
                apellido_materno: values.apellido_materno,
                dni: values.dni, 
                nivel: values.nivel,
                grado: values.grado,
                seccion: values.seccion,
                email: values.email,
                region: values.region,
                provincia: values.provincia,
                distrito: values.distrito,
                tipo_inst_edu: values.tipo_inst_edu,
                profesor: values.profesor,
                nacionalidad: values.nacionalidad,
                genero: values.genero,
                inst_educativa: values.inst_educativa,
                formato: values.formato,
                region_muni: (values.formato == '95' ? values.region_muni : ''),
                provincia_muni: (values.formato == '95' ? values.provincia_muni : ''),
                distrito_muni: (values.formato == '95' ? values.distrito_muni : ''),
                municipalidad: (values.formato == '95' ? values.municipalidad : ''),
                referencia_muni: (values.formato == '95' ? values.referencia_muni : ''),
                latitud_mapa: ubicacion.lat,
                longitud_mapa: ubicacion.lng,
                referencia_mapa: referencia_mapa,
                existe_observacion: values.existe_observacion,
                lista_formato: formatos.listado,
                id_veeduria: estudiante.id_veeduria
            }
            setOpenResetForm(false);
            payload.municipalidad = existe_observacion ? '' : payload.municipalidad

            console.log('nombrev ', localStorage.getItem('nombre'))
            console.log('fnombre v', values.nombre)
// veeduria.message = ''
            if (validaSeleccionFormato()){
                if (validaPreguntas()){
                    console.log('payload::::::::', payload)
                    dispatch( insertVeeduriaBD( payload ) ) 
                }
            }
/*
            setTimeout(() => {
                setSubmitting(false)
            }, 5000);
 */           

        } }
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                isValid,
                setFieldValue,
                ...props
            }) => (
                <form 
                className={ classes.form }
                autoComplete="off"
                id="frm-estudiante"
                onSubmit={ handleSubmit }>
                {/* <Alerta state={ alert } handleClose={ handleCloseAlert }/> */}
                    
                <ConfirmControl
                            classes={{
                                paper: classes.paper,
                            }}
                            id="menu"
                            keepMounted
                            open={ alert.open }
                            // onSubmit={ handleSubmit }
                            onSubmit={ handleCloseAlert }
                            onClose={ handleCloseAlert }
                            dni={ "" }
                            alerta={ true }
                            nombre={ "" } />

                    {/* Inicio: Estudiante */}
                    {
                        (informacion_basica.cargo == '007')
                        &&
                        <div>
                            <a id="ancla_estudiante"></a>
                            <Accordion expanded={ expandedHijo } id="acordionEstudiante" onChange={ () => { setexpandedHijo( !expandedHijo ) } }
                            disabled={padre.severity !== 'success'} style={{ marginTop: "12px" }} >
                                <StyledAccordionSummary aria-controls="panel2a-content" id="panel2a-header"
                                expandIcon={ <ExpandMoreIcon className={ classes.iconExpander }/> } >
                                    <Typography className={ classes.heading }>
                                        Datos del estudiante
                                    </Typography>
                                </StyledAccordionSummary>
                                <AccordionDetails className={ classes.detalle }>
                                    
                                    <div className="ed-grid rows-gap s-gap-3 m-gap-3 l-gap-3 s-grid-2 m-grid-6 lg-grid-12">
                                        <div className="s-y-1 s-x-1 s-cols-2
                                                        m-y-1 m-x-1 m-cols-2
                                                        l-y-1 l-x-1 l-cols-2">
                                            <div className={ classes.wrapper }>
                                                <FormControl className={ classes.formControl } 
                                                fullWidth
                                                size="small"
                                                id="form-tipo-doc-hijo"
                                                name="tipo_doc_hijo"
                                                variant="outlined"
                                                error={ touched.tipo_doc_hijo && Boolean( errors.tipo_doc_hijo ) }
                                                >
                                                    <InputLabel id="tipo-documento-hijo-label" className={ classes.selectStyle} >
                                                        Tipo documento
                                                    </InputLabel>
                                                    <Select 
                                                    labelId="tipo-documento-hijo-label"
                                                    id="tipo-documento-hijo-select-outlined"
                                                    className={ classes.selectStyle } 
                                                    value={ values.tipo_doc_hijo }
                                                    label="Tipo documento"
                                                    onBlur={ handleBlur( 'tipo_doc_hijo' ) }
                                                    disabled={ tipos_documento.isLoading }
                                                    onChange={ e => {
                                                        const { value } = e.target
                                                        
                                                        setFieldValue( "tipo_doc_hijo", value )
                                                        
                                                        if (nacionalidades.listado.length === 0)
                                                            dispatch( getNacionalidadesBD() )
                                                        
                                                        setFieldValue( "dni", '' )
                                                        dispatch( resetValidacion( { tipo_doc_hijo: value, isValidated: false, message: '', severity: '' }) )
                                                        
                                                        if ( value === '0101' ) {
                                                            setFieldValue( "nacionalidad", '0301' )
                                                            
                                                            setFieldValue("generos", generos);
                                                        }
                                                        else{
                                                            setFieldValue( "nacionalidad", '' )
                                                        }
    
                                                    } }
                                                    >
                                                        {
                                                            tipos_documento.listado.map( ( opt, i) => (
                                                                (opt.PARAMETRO_COD == '0101' || opt.PARAMETRO_COD == '0102' || opt.PARAMETRO_COD == '0103' || opt.PARAMETRO_COD == '0104')
                                                                && <MenuItem className={ classes.selectStyle }  key={ i } value={ opt.PARAMETRO_COD }>{ opt.PARAMETRO_DES }</MenuItem>
                                                            ) )
                                                        }
                                                    </Select>
                                                    {
                                                        touched.tipo_doc_hijo
                                                        ? <FormHelperText className={ classes.selectStyle} >{ errors.tipo_doc_hijo }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                                { tipos_documento.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                            </div>
                                        </div>
                                        <div className="s-y-2 s-x-1 s-cols-2
                                                        m-y-1 m-x-3 m-cols-2
                                                        l-y-1 l-x-3 l-cols-2">
                                            <div className={ classes.wrapper }>
                                                <FormControl  className={ classes.formControl } 
                                                fullWidth
                                                size="small"
                                                id="form-nacionalidad"
                                                name="nacionalidad"
                                                variant="outlined"
                                                error={ touched.nacionalidad && Boolean( errors.nacionalidad ) }
                                                >
                                                    <InputLabel id="nacionalidad-label" className={ classes.selectStyle} >
                                                        Nacionalidad
                                                    </InputLabel>
                                                    <Select className={ classes.selectStyle } 
                                                    value={ values.nacionalidad }
                                                    labelId="nacionalidad-label"
                                                    id="nacionalidad"
                                                    name="nacionalidad"
                                                    label="Nacionalidad"
                                                    onBlur={ handleBlur( 'nacionalidad' ) }
                                                    // onChange={ handleChange( 'nacionalidad' ) }
                                                    disabled={ nacionalidades.isLoading || values.tipo_doc_hijo === '0101' }
                                                    onChange={ e => {
                                                        const { value } = e.target
    
                                                        setFieldValue( "nacionalidad", value )
                                                        setFieldValue( "generos", generos );
    
                                                    } }
                                                    >
                                                        {
                                                            nacionalidades.listado.length === 0
                                                            ?
                                                                <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                            :
                                                                nacionalidades.listado.map( ( opt, i) => (
                                                                    <MenuItem className={ classes.selectStyle }  key={ i } value={ opt.PARAMETRO_COD }
                                                                    selected>{ opt.PARAMETRO_DES }</MenuItem>
                                                                ) )
                                                        }
    
                                                    </Select>
                                                    {
                                                        touched.nacionalidad
                                                        ? <FormHelperText className={ classes.selectStyle} >{ errors.nacionalidad }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                                { nacionalidades.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                            </div>
                                        </div>
                                        
                                        <div className="s-y-3 s-x-1 s-cols-2
                                                        m-y-1 m-x-5 m-cols-2
                                                        l-y-1 l-x-5 l-cols-2">
                                            <div className={ classes.wrapper }>
                                                {
                                                    values.tipo_doc_hijo === '0101'
                                                    ?   
                                                        // <MyField name="dni"/>
                                                        <>
                                                            <TextField className={ classes.inputStyle} 
                                                            fullWidth 
                                                            size="small"
                                                            name="dni"
                                                            label="Nro documento"
                                                            variant="outlined"
                                                            value={ values.dni }
                                                            onBlur={ handleBlur }
                                                            autoComplete="off"
                                                            helperText={ touched.dni ? errors.dni : "" }
                                                            error={ touched.dni && Boolean( errors.dni ) }
                                                            pattern="[0-9]*"
                                                            inputProps={ { inputComponent: TextNumber, maxLength: 8 } }
                                                            disabled={ estudiante.isLoading }
                                                            onChange={ ( { target } ) => {
                                                                const re = /^[0-9\b]+$/;
                                                                console.log(target.value)


                                                                localStorage.removeItem('generodiv');
                                                                localStorage.removeItem('secciondiv');
                                                                localStorage.removeItem('gradodiv');

                                                                if ( target.value === '' || re.test( target.value)) {
                                                                    console.log(target.value)
                                                                    setFieldValue( "dni", target.value )
                                                                    
                                                                    if (target.value.length === 8) {
                                                                       if (target.value !== padre.dni) {
                                                                            dispatch( validarDNI( { dni: target.value, tipo_doc_hijo: estudiante.tipo_doc_hijo, lista_formato: formatos.listado } ) )
                                                                            dispatch( resetRegiones() )
                                                                            dispatch( resetProvincias() )
                                                                            dispatch( resetDistritos() )
                                                                            dispatch( resetInstituciones() )        
                                                                            setFieldValue("nivel", '');
                                                                            setFieldValue("grado", '');
                                                                            setFieldValue("seccion", '');
                                                                            setFieldValue("region", '');
                                                                            setFieldValue("provincia", '')
                                                                            setFieldValue("distrito", '')
                                                                            setFieldValue('inst_educativa', '' );
                                                                            setFieldValue('formato', '' );
                                                                            setFieldValue( "dni", target.value )
                                                                        }
                                                                        else {
                                                                            setFieldValue("dni", '');
                                                                            Mensaje('El Nro. documento del estudiante no puede ser igual al del padre', '¡Aviso!', 'info')
                                                                        }
                                                                    }
                                                                
                                                                }
                                                                else{
                                                                    let valorDNI = target.value.substring(0, target.value.length - 1);
                                                                    setFieldValue( "dni", valorDNI )
                                                                }
    
                                                            } }
                                                            />
                                                        </>
                                                    :   
                                                        values.tipo_doc_hijo === '0102' || values.tipo_doc_hijo === '0103' || values.tipo_doc_hijo === '0104'
                                                        ? 
                                                            <TextField className={ classes.inputStyle}
                                                            fullWidth 
                                                            size="small"
                                                            label="Nro. documento"
                                                            name="dni"
                                                            variant="outlined"
                                                            autoComplete="off"
                                                            value={ values.dni }
                                                            onBlur={ handleBlur }
                                                            disabled={ estudiante.isLoading }
                                                            helperText={ touched.dni ? errors.dni : "" }
                                                            error={ touched.dni && Boolean( errors.dni ) }
                                                            inputProps={ { style: { textTransform: 'uppercase' }, maxLength: 12 } }
                                                            onChange={(event) => {
                                                                const regex = /^([a-z0-9]+)$/i;
                                                                if (event.target.value === '' || regex.test(event.target.value)) {
                                                                    setFieldValue("dni", event.target.value);
    
                                                                    if (event.target.value.length === 12)
                                                                    {
                                                                        if (event.target.value !== padre.dni)
                                                                        {
                                                                            dispatch( validarDNI( { dni: event.target.value,
                                                                                tipo_doc_hijo: values.tipo_doc_hijo,
                                                                                lista_formato: formatos.listado } ) );
                                                                            dispatch( resetRegiones() )
                                                                            dispatch( resetProvincias() )
                                                                            dispatch( resetDistritos() )
                                                                            dispatch( resetInstituciones() )
                                                                            setFieldValue("nivel", '');
                                                                            setFieldValue("grado", '');
                                                                            setFieldValue("seccion", '');
                                                                            setFieldValue("region", '');
                                                                            setFieldValue("provincia", '')
                                                                            setFieldValue("distrito", '')
                                                                            setFieldValue('inst_educativa', '' );
                                                                            setFieldValue('formato', '' );
                                                                            setFieldValue("dni", event.target.value);
                                                                        }
                                                                        else {
                                                                            setFieldValue("dni", '');
                                                                            Mensaje('El Nro. documento del estudiante no puede ser igual al del padre', '¡Aviso!', 'info')
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            />
                                                        :
                                                            null
                                                }
                                                { estudiante.isLoading && <CircularProgress size={ 20 } className={ classes.fieldProgress } /> }
                                            </div>
                                        </div>
                                        <div className="s-y-4 s-x-1 s-cols-2 
                                                        m-y-2 m-x-1 m-cols-2
                                                        l-y-2 l-x-1 l-cols-2">   
                                            <TextField  className={ classes.inputStyle}
                                            fullWidth 
                                            size="small"
                                            label="Nombres"
                                            name="nombre"
                                            id = "cabnombre"
                                            variant="outlined"
                                            autoComplete="none"
                                            
                                            value={ values.nombre }
                                            onBlur={ handleBlur }
                                            // onChange={ handleChange }
                                            onChange={(event) => {
                                                const regex = /^([a-zñáéíóú ]+)$/i;
                                                if (event.target.value === '' || regex.test(event.target.value)) {
                                                    setFieldValue("nombre", event.target.value);
                                                }
                                            }}
                                            helperText={ touched.nombre ? errors.nombre : ""}
                                            error={ touched.nombre && Boolean( errors.nombre ) }
                                            inputProps={ { style: { textTransform: 'capitalize' }, maxLength: 50 } }
                                            />
                                        </div>
                                        <div className="s-y-5 s-x-1 s-cols-2
                                                        m-y-2 m-x-3 m-cols-2
                                                        l-y-2 l-x-3 l-cols-2">
                                            <TextField  className={ classes.inputStyle}
                                            fullWidth 
                                            size="small"
                                            label="Apellido paterno"
                                            name="apellido_paterno"
                                            id = "cabappaterno"
                                            autoComplete="none"
                                            variant="outlined"
                                            value={ values.apellido_paterno }
                                            onBlur={ handleBlur }
                                            // onChange={ handleChange }
                                            helperText={ touched.apellido_paterno ? errors.apellido_paterno : ""}
                                            error={ touched.apellido_paterno && Boolean( errors.apellido_paterno ) }
                                            inputProps={ { style: { textTransform: 'capitalize' }, maxLength: 50 } }
                                            onChange={(event) => {
                                                const regex = /^([a-zñáéíóú ]+)$/i;
                                                if (event.target.value === '' || regex.test(event.target.value)) {
                                                    setFieldValue("apellido_paterno", event.target.value);
                                                }
                                            }}
                                            />
                                        </div>
                                        <div className="s-y-6 s-x-1 s-cols-2
                                                        m-y-2 m-x-5 m-cols-2
                                                        l-y-2 l-x-5 l-cols-2">
                                            <TextField  className={ classes.inputStyle} 
                                            fullWidth 
                                            size="small"
                                            label="Apellido materno"
                                            name="apellido_materno"
                                            id = "cabapmaterno"
                                            autoComplete="none"
                                            variant="outlined"
                                            value={ values.apellido_materno }
                                            onBlur={ handleBlur }
                                            // onChange={ handleChange }
                                            helperText={ touched.apellido_materno ? errors.apellido_materno : ""}
                                            error={ touched.apellido_materno && Boolean( errors.apellido_materno ) }
                                            inputProps={ { style: { textTransform: 'capitalize' }, maxLength: 50 } }
                                            onChange={(event) => {
                                                const regex = /^([a-zñáéíóú ]+)$/i;
                                                if (event.target.value === '' || regex.test(event.target.value)) {
                                                    setFieldValue("apellido_materno", event.target.value);
                                                }
                                            }}
                                            />
                                        </div>
                                        
                                        <div className="s-y-7 s-x-1 s-cols-2
                                                        m-y-3 m-x-1 m-cols-2
                                                        l-y-2 l-x-7 l-cols-2">
                                            <FormControl  className={ classes.formControl } 
                                            fullWidth
                                            size="small"
                                            id="form-genero"
                                            name="genero"
                                            variant="outlined"
                                            error={ touched.genero && Boolean( errors.genero ) }
                                            >
                                                <InputLabel id="genero-label" className={ classes.selectStyle} >
                                                    Género
                                                </InputLabel>
                                                <Select className={ classes.selectStyle} 
                                                value={ values.genero }
                                                labelId="genero-label"
                                                id="genero"
                                                name="genero"
                                                label="Género."
                                                onBlur={ handleBlur( 'genero' ) }
                                       

                                                onChange={ e => {
                                                            
	                                                        const { value } = e.target
                                                            localStorage.setItem('generodiv', value);	
                                                            console.log('generodiv', value)
                                                            handleChange( 'genero' )
                                                            setFieldValue( "genero", value )
                                                } }
                                                >
                                                {
                                                    values.generos
                                                    ?
                                                        values.generos.map( item => (
                                                            <MenuItem  className={ classes.selectStyle} key={ item.cod } value={ item.cod }>{ item.des }</MenuItem>
                                                        ) )
                                                    :
                                                        <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                }
                                                </Select>
                                                {
                                                    touched.genero
                                                    ? <FormHelperText className={ classes.selectStyle} >{ errors.genero }</FormHelperText>
                                                    : null
                                                }
                                            </FormControl>
                                        </div>
                                        
                                    

                                                        <div className="s-y-8 s-x-1 s-cols-2
                                                        m-y-3 m-x-3 m-cols-4
                                                        l-y-2 l-x-9 l-cols-4">


                                            <TextField  className={ classes.inputStyle} 
                                            fullWidth
                                            size="small"
                                            label="Correo electrónico"
                                            name="email"
                                            id = "cabcorreo"
                                           // required="false"
                                            autoComplete="none"
                                            variant="outlined"
                                            value={ values.email }
                                            onBlur={ handleBlur }
                                            // onChange={ handleChange }
                                            helperText={ touched.email ? errors.email : ""}
                                           // error={ touched.email && Boolean( errors.email ) }
                                            inputProps={ { style: { textTransform: 'lowercase' }, maxLength: 200 } }
                                           
                                            onChange={(event) => {
                                                const regex = /^([a-z0-9@.\-_ ]+)$/i;
                                                if (event.target.value === '' || regex.test(event.target.value)) {
                                                    setFieldValue("email", event.target.value);
                                                }
                                            }}
                                            />
                                        </div>
                                    </div>
                                </AccordionDetails>
{/*                                 
                                <Alerta state={ alert } handleClose={ handleCloseAlert }/> */}
                            </Accordion>
                        </div>
                    }
                    {/* Fin: Estudiante */}
                    
                    
                    {/* Inicio: Institucion Educativa */}
                    <div>
                        <a id="ancla_institucion"></a>
                        {
                            ((!errors.dni && values.dni !== '' && informacion_basica.cargo == '007') || informacion_basica.cargo != '007')
                            &&
                            <Accordion expanded={ expandedIE } id="acordionInstitucion" onChange={ () => { setexpandedIE( !expandedIE ) } }
                            disabled={padre.severity !== 'success'} style={{ marginTop: "12px" }} >
                                <StyledAccordionSummary aria-controls="panel2a-content" id="panel2a-header"
                                expandIcon={ <ExpandMoreIcon className={ classes.iconExpander }/> } >
                                    <Typography className={ classes.heading }>
                                        Datos de la institución educativa
                                    </Typography>
                                </StyledAccordionSummary>
                                <AccordionDetails className={ classes.detalle }>
                                    
                                    <div className="ed-grid rows-gap s-gap-3 m-gap-3 l-gap-3 s-grid-2 m-grid-6 lg-grid-12">
                                        <div className="s-y-1 s-x-1 s-cols-2
                                                        m-y-1 m-x-1 m-cols-3
                                                        l-y-1 l-x-1 l-cols-2">
                                            <div className={ classes.wrapper }>
                                                <FormControl  className={ classes.formControl } 
                                                fullWidth
                                                size="small"
                                                id="form-tipo-inst-edu"
                                                name="tipo_inst_edu"
                                                variant="outlined"
                                                error={ touched.tipo_inst_edu && Boolean( errors.tipo_inst_edu ) }
                                                >
                                                    <InputLabel id="tipo-label" className={ classes.selectStyle}>
                                                        Tipo
                                                    </InputLabel>
                                                    <Select  className={ classes.selectStyle}
                                                    labelId="tipo-label"
                                                    id="tipo-outlined"
                                                    label="Tipo"
                                                    // value={ values.tipo_inst_edu }
                                                    value={ estudiante.tipo_inst_edu }
                                                    onBlur={ handleBlur( 'tipo_inst_edu' ) }
                                                    disabled={ tipos_inst_edu.isLoading }
                                                    onChange={ e => {
                                                        const { value } = e.target

                                                        setFieldValue( "tipo_inst_edu", value )
                                                        setFieldValue( "niveles", niveles );
                                                        setFieldValue("inst_educativa", '');
                                                        setFieldValue( 'formato', '' )
    

                                                        // PARA LA VEEDURÍA DE MANTENIMIENTO
                                                        // ------------ INICIO -------------
                                                        if (informacion_basica.cargo != '007'){
                                                            setFieldValue("nivel", 'S');
                                                            setFieldValue("inst_educativa", '');
                                                            setFieldValue( 'formato', '' )
            
                                                            localStorage.setItem('saj_nivel', 'S');
                                                            localStorage.removeItem('id_formato_selected');
                                                            setFieldValue("grados", grados_secundaria)
            
                                                            if( regiones.listado.length === 0 )
                                                                dispatch( getRegionesBD() )
            
                                                            dispatch( resetInstituciones() )
                                                                
                                                            formatos.listado.forEach(element => {
                                                                element.HABILITADO = false;
                                                            });
                                                        }
                                                        // if (informacion_basica.cargo == '007')
                                                        //     setFieldValue("secciones", secciones);
                                                        // ------------- FIN --------------

                                                        dispatch( resetInstituciones() )
                                                            
                                                        formatos.listado.forEach(element => {
                                                            element.HABILITADO = false;
                                                        });
    
                                                        if ( values.distrito !== '' ){
                                                            dispatch( getInstitucionesBD( values.region, 
                                                                                        values.provincia,
                                                                                        values.distrito,
                                                                                        values.nivel,
                                                                                        value,
                                                                                        (informacion_basica.cargo == '007' ? '0' : '1') ) )
                                                        }
                                                        
                                                        dispatch( updateDato( {tipo_inst_edu: value } ) )
                                                        dispatch( updateDato( {id_veeduria: padre.id_veeduria } ) )
                                                        dispatch( updatePadre( {id_veeduria: '0' } ) )
                                                        

                                                    } }
                                                    >
                                                        {
                                                            tipos_inst_edu.listado.map( ( opt, i) => (
                                                                informacion_basica.cargo !== '007' ? (
                                                                    opt.PARAMETRO_COD !== '0203' ? (
                                                                        <MenuItem className={classes.selectStyle} key={i} value={opt.PARAMETRO_COD}>{opt.PARAMETRO_DES}</MenuItem>
                                                                    ) : null
                                                                ) : <MenuItem className={classes.selectStyle} key={i} value={opt.PARAMETRO_COD}>{opt.PARAMETRO_DES}</MenuItem>
                                                            ) )
                                                        }
                                                    </Select>
                                                    {
                                                        touched.tipo_inst_edu
                                                        ? <FormHelperText className={ classes.selectStyle} >{ errors.tipo_inst_edu }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                                {
                                                    values.tipo_inst_edu === '0202'
                                                    ? 
                                                        <FormHelperText className={ classes.selectStyle} >{ 'Si no encuentra su I.E. seleccione "I.E. PRIVADA"' }</FormHelperText>
                                                    : 
                                                        values.tipo_inst_edu === '0203'
                                                        ? <FormHelperText className={ classes.selectStyle} >{ 'Si no encuentra su I.E. seleccione "I.E. POR CONVENIO"' }</FormHelperText>
                                                        : null
                                                }
                                                { tipos_inst_edu.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                            </div>
                                        </div>
                                        <div className="s-y-2 s-x-1 s-cols-2
                                                        m-y-1 m-x-4 m-cols-3
                                                        l-y-1 l-x-3 l-cols-2">
                                            <FormControl  className={ classes.formControl } 
                                            fullWidth
                                            size="small"
                                            id="form-nivel"
                                            name="nivel"
                                            variant="outlined"
                                            disabled={informacion_basica.cargo !== '007'}
                                            error={ touched.nivel && Boolean( errors.nivel ) }
                                            >
                                                <InputLabel id="nivel-label" className={ classes.selectStyle} >
                                                    Nivel
                                                </InputLabel>
                                                <Select  className={ classes.selectStyle} 
                                                    labelId="nivel-label"
                                                    id="nivel-outlined"
                                                    label="Nivel"
                                                    value={ values.nivel }
                                                    onBlur={ handleBlur( 'nivel' ) }
                                                    onChange={ e => {
                                                        const { value } = e.target
        
                                                        setFieldValue("nivel", value);
                                                        setFieldValue("inst_educativa", '');
                                                        setFieldValue( 'formato', '' )
        
                                                        localStorage.setItem('saj_nivel', value);
                                                        localStorage.removeItem('id_formato_selected');

                                                        if ( value === 'P')
                                                            setFieldValue("grados", grados_primaria)
                                                        else
                                                            setFieldValue("grados", grados_secundaria)
        
                                                        setFieldValue("secciones", secciones);
        
                                                        console.log('regiones.listado', regiones.listado)
                                                        if( regiones.listado.length === 0 )
                                                            dispatch( getRegionesBD() )
        
                                                        dispatch( resetInstituciones() )
                                                            
                                                        formatos.listado.forEach(element => {
                                                            element.HABILITADO = false;
                                                        });
                                                        
                                                        if ( values.distrito !== '' ){
                                                            dispatch( getInstitucionesBD( values.region, 
                                                                                        values.provincia,
                                                                                        values.distrito,
                                                                                        value,
                                                                                        values.tipo_inst_edu,
                                                                                        (informacion_basica.cargo == '007' ? '0' : '1') ) )
                                                        }
                                                    
                                                    } }
                                                >
                                                    {
                                                        niveles
                                                        ?
                                                        niveles.map( nivel => (
                                                                <MenuItem  className={ classes.selectStyle} key={ nivel.cod } value={ nivel.cod }>{ nivel.des }</MenuItem>
                                                            ) )
                                                        :
                                                            <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                    }
                                                </Select>
                                                {
                                                    touched.nivel
                                                    ? <FormHelperText className={ classes.selectStyle} >{ errors.nivel }</FormHelperText>
                                                    : null
                                                }
                                            </FormControl>
                                        </div>
                                        {
                                            (informacion_basica.cargo == '007')
                                            &&
                                            <>
                                            <div className="s-y-3 s-x-1 s-cols-2
                                                            m-y-2 m-x-1 m-cols-3
                                                            l-y-1 l-x-5 l-cols-2">
                                                <FormControl  className={ classes.formControl } 
                                                fullWidth
                                                size="small"
                                                id="form-grado"
                                                name="grado"
                                                variant="outlined"
                                                error={ touched.grado && Boolean( errors.grado ) }
                                                >
                                                    <InputLabel id="grado-label" className={ classes.selectStyle} >
                                                        Grado
                                                    </InputLabel>
                                                    <Select  className={ classes.selectStyle} 
                                                    value={ values.grado }
                                                    id="grado"
                                                    name="grado"
                                                    labelId="grado-label"
                                                    label="Grado"
                                                    onBlur={ handleBlur( 'grado' ) }
                                                    

                                                    onChange={(event) => {
                                                    handleChange( 'grado' ) ;
                                                    setFieldValue("grado", event.target.value);
                                                    
                                                    localStorage.setItem('gradodiv', event.target.value);	
	                                                console.log('gradodiv', event.target.value)
                                                }}


                                                    autoComplete="none"
                                                    >
                                                    {
                                                        values.grados
                                                        ?
                                                            values.grados.map( grado => (
                                                                <MenuItem  className={ classes.selectStyle} value={ grado.cod } autoComplete="none">{ grado.des }</MenuItem>
                                                                // <MenuItem value={ grado.cod }>{ decode(grado.des) }</MenuItem>
                                                            ) )
                                                        :
                                                            <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                    }
                                                    </Select>
                                                    {
                                                        touched.grado
                                                        ? <FormHelperText className={ classes.selectStyle} >{ errors.grado }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                            </div>
                                            <div className="s-y-4 s-x-1 s-cols-2
                                                            m-y-2 m-x-4 m-cols-3
                                                            l-y-1 l-x-7 l-cols-2">
                                                <FormControl  className={ classes.formControl } 
                                                fullWidth
                                                size="small"
                                                id="form-seccion"
                                                name="seccion"
                                                variant="outlined"
                                                error={ touched.seccion && Boolean( errors.seccion ) }
                                                >
                                                    <InputLabel id="seccion-label" className={ classes.selectStyle} >
                                                        Sección
                                                    </InputLabel>
                                                    <Select  className={ classes.selectStyle}
                                                    id="seccion"
                                                    name="seccion"
                                                    labelId="seccion-label"
                                                    label="Sección"
                                                    value={ values.seccion }
                                                    onBlur={ handleBlur( 'seccion' ) }
                                                    onChange={(event) => {
                                                    handleChange( 'seccion' ) ;
                                                    setFieldValue("seccion", event.target.value);
                                                    
                                                    localStorage.setItem('secciondiv', event.target.value);	
	                                                console.log('secciondiv', event.target.value)
                                                }}


                                                    autoComplete="none"
                                                    >
                                                    {
                                                        values.secciones
                                                        ?
                                                            values.secciones.map( seccion => (
                                                                <MenuItem  className={ classes.selectStyle} value={ seccion.cod } autoComplete="none">{ seccion.des }</MenuItem>
                                                            ) )
                                                        :
                                                            <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                    }
                                                    </Select>
                                                    {
                                                        touched.seccion
                                                        ? <FormHelperText className={ classes.selectStyle} >{ errors.seccion }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                            </div>
                                            <div className="s-y-5 s-x-1 s-cols-2
                                                            m-y-3 m-x-1 m-cols-6
                                                            l-y-1 l-x-9 l-cols-4">
                                                <TextField
                                                fullWidth 
                                                size="small"
                                                label="Profesor(a) que acompaña la veeduría escolar"
                                                required="true"
                                                name="profesor"
                                                id="cabprofesor"
                                                variant="outlined"
                                                autoComplete="off"
                                                value={ values.profesor }
                                                onBlur={ handleBlur }
                                                helperText={ touched.profesor ? errors.profesor : "" }
                                                error={ touched.profesor && Boolean( errors.profesor ) }
                                                inputProps={ { style: { textTransform: 'capitalize' }, maxLength: 50 } }
                                                onChange={(event) => {
                                                    const regex = /^([a-zñáéíóú ]+)$/i;
                                                    if (event.target.value === '' || regex.test(event.target.value)) {
                                                        setFieldValue("profesor", event.target.value);
                                                    }
                                                }}
                                                className={ classes.inputStyle } //agregado
                                                />
                                            </div>
                                            </>
                                        }
                                        <div className={`${informacion_basica.cargo == '007'
                                                ? 
                                                    "s-y-6 s-x-1 s-cols-2    m-y-4 m-x-1 m-cols-2    l-y-2 l-x-1 l-cols-2"
                                                : 
                                                    "s-y-3 s-x-1 s-cols-2    m-y-2 m-x-1 m-cols-2    l-y-2 l-x-1 l-cols-2"}`}
                                        > 
                                            <div className={ classes.wrapper }>
                                                <FormControl  className={ classes.formControl } 
                                                fullWidth
                                                size="small"
                                                id="region"
                                                name="region"
                                                variant="outlined"
                                                error={ touched.region && Boolean( errors.region ) }
                                                >
                                                    <InputLabel id="region-label" className={ classes.selectStyle} >
                                                        Región
                                                    </InputLabel>
                                                    <Select  className={ classes.selectStyle} 
                                                    labelId="region-label"
                                                    label="Región"
                                                    value={ values.region }
                                                    onBlur={ handleBlur( 'region' ) }
                                                    disabled={ regiones.isLoading }
                                                    onChange={ e => {
                                                        const { value } = e.target
    
                                                        let datosRegion = {};
                                                        regiones.listado.forEach(element => {
                                                            if (element.REGION_COD === value)
                                                                datosRegion = element;
                                                        });
    
                                                        setFieldValue( "region", value )
                                                        console.log('region del div', value)
                                                        

                                                        localStorage.setItem('valordiv', value);	
                                                        console.log('valordiv', value)
                                                        
                                                        // Valida si las veedurías activas ya fueron rigistradas por el estudicante
                                                        let formatos_activos = datosRegion.FORMATOS.split(';');
                                                        let cantidad_registrados = 0;
                                                        formatos_activos.forEach(element_1 => {
                                                            estudiante.lista_formato.forEach(element_2 => {
                                                                if (element_1 == element_2.FORMATO_COD && element_2.SELECTED)
                                                                cantidad_registrados += 1;
                                                                debugger
                                                            });
                                                        });
 /*                                                      
 console.log('formatos_activos ', formatos_activos);                                                       
  console.log('cantidad_registrados ', cantidad_registrados);                                  

                                                        if (formatos_activos.length == cantidad_registrados) {
                                                            Mensaje( "El DNI " + estudiante.dni + ", ya participó en la veeduría.", 'Aviso', 'info' )
                                                            dispatch( resetValidacion( { isValidated: false, message: '', severity: '' }) )
                                                            dispatch( resetProvincias() )
                                                            dispatch( resetDistritos() )
                                                            dispatch( resetInstituciones() )
                                                            setFieldValue("provincia", '')
                                                            setFieldValue("distrito", '')
                                                            setFieldValue("inst_educativa", '')
                                                            setFieldValue( 'formato', '' )
                                                            return false;
                                                        }*/


                                                        if ( !value ) {
                                                            dispatch( resetDistritos() )
                                                            dispatch( resetInstituciones() )
                                                            setFieldValue("provincia", '')
                                                            setFieldValue("distrito", '')
                                                            setFieldValue("inst_educativa", '')
                                                            setFieldValue( 'formato', '' )
                                                        }
                                                        else {
                                                            const localTime = moment().format('YYYY-MM-DD')
                                                            const today = localTime + "T00:00:00"
    
                                                            const localFinicio = moment(datosRegion.FECHA_INICIO).format('YYYY-MM-DD')
                                                            const first = localFinicio + "T00:00:00"
    
                                                            const localFin = moment(datosRegion.FECHA_FIN).format('YYYY-MM-DD')
                                                            const last = localFin + "T00:00:00"
    
                                                            const HOY = moment(today).unix()
                                                            const INICIO = moment(first).unix()
                                                            const FIN = moment(last).unix()
    
                                                            if (FIN < HOY)
                                                            {
                                                                dispatch( resetProvincias() )
                                                                setFieldValue( "region", '' )
                                                                Mensaje(`
                                                                El registro de veedurías para esta región fue:
                                                                <br>
                                                                <br>
                                                                Del ${ moment(datosRegion.FECHA_INICIO).format('DD/MM/YYYY') } al ${ moment(datosRegion.FECHA_FIN).format('DD/MM/YYYY') }
                                                                <br>
                                                                `, '¡Aviso!', 'info')
                                                            }
                                                            else if (INICIO > HOY)
                                                            {
                                                                dispatch( resetProvincias() )
                                                                setFieldValue( "region", '' )
                                                                Mensaje(`
                                                                El registro de veedurías para esta región será:
                                                                <br>
                                                                <br>
                                                                Del ${ moment(datosRegion.FECHA_INICIO).format('DD/MM/YYYY') } al ${ moment(datosRegion.FECHA_FIN).format('DD/MM/YYYY') }
                                                                <br>
                                                                <br>
                                                                `, '¡Aviso!', 'info')
                                                            }
                                                            else{
                                                                if ( !value ) {
                                                                    dispatch( resetProvincias() )
                                                                    setFieldValue( "region", '' )
                                                                }
                                                                else {
                                                                    dispatch( getProvinciasBD( value ) )
                                                                    setFieldValue( "region", value )
                                                                }
                                                            }
                                                            dispatch( resetDistritos() )
                                                            dispatch( resetInstituciones() )
                                                            setFieldValue("provincia", '')
                                                            setFieldValue("distrito", '')
                                                            setFieldValue("inst_educativa", '')
                                                            setFieldValue( 'formato', '' )
                                                        }

                                                        formatos.listado.forEach(element => {
                                                            element.HABILITADO = false;
                                                        });

                                                        
                                                    } }
                                                    >
                                                    {
                                                        regiones.listado.length === 0
                                                        ?
                                                            <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                        :
                                                            regiones.listado.map( ( opt, i) => (
                                                                <MenuItem  className={ classes.selectStyle} key={ i } value={ opt.REGION_COD }>{ opt.REGION_DES }</MenuItem>
                                                            ) )
                                                    }
                                                    </Select>
                                                    {
                                                        touched.region
                                                        ? <FormHelperText className={ classes.selectStyle} >{ errors.region }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                                { regiones.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                            </div>
                                        </div>
                                        <div className={`${informacion_basica.cargo == '007'
                                                ? 
                                                    "s-y-7 s-x-1 s-cols-2    m-y-4 m-x-3 m-cols-2    l-y-2 l-x-3 l-cols-2"
                                                : 
                                                    "s-y-4 s-x-1 s-cols-2    m-y-2 m-x-3 m-cols-2    l-y-2 l-x-3 l-cols-2"}`}
                                        >
                                            <div className={ classes.wrapper }>
                                                <FormControl  className={ classes.formControl } 
                                                fullWidth
                                                size="small"
                                                id="provincia"
                                                name="provincia"
                                                variant="outlined"
                                                error={ touched.provincia && Boolean( errors.provincia ) }
                                                >
                                                    <InputLabel id="provincia-label" className={ classes.selectStyle} >
                                                        Provincia
                                                    </InputLabel>
                                                    <Select  className={ classes.selectStyle}
                                                    labelId="provincia-label"
                                                    label="Provincia"
                                                    value={ values.provincia }
                                                    onBlur={ handleBlur( 'provincia' ) }
                                                    disabled={ provincias.isLoading }
                                                    onChange={ e => {
                                                        const { value } = e.target
        
                                                        if ( !value ) {
                                                            dispatch( resetDistritos() )
                                                            setFieldValue( "provincia", '' )
                                                        }
                                                        else {
                                                            dispatch( getDistritosBD( values.region, value ) )
                                                            setFieldValue( "provincia", value )
                                                        }
                                                        dispatch( resetInstituciones() )
                                                        setFieldValue("distrito", '')
                                                        setFieldValue("inst_educativa", '')
                                                        setFieldValue( 'formato', '' )

                                                        formatos.listado.forEach(element => {
                                                            element.HABILITADO = false;
                                                        });

                                                    } }
                                                    >
                                                    {
                                                        provincias.listado.length === 0
                                                        ?
                                                            <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                        :
                                                            provincias.listado.map( ( opt, i) => (
                                                                <MenuItem  className={ classes.selectStyle} key={ i } value={ opt.PROVINCIA_COD }>{ opt.PROVINCIA_DES }</MenuItem>
                                                            ) )
                                                    }
                                                    </Select>
                                                    {
                                                        touched.provincia
                                                        ? <FormHelperText className={ classes.selectStyle} >{ errors.provincia }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                                { provincias.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                            </div>
                                        </div>
                                        <div className={`${informacion_basica.cargo == '007'
                                                ? 
                                                    "s-y-8 s-x-1 s-cols-2    m-y-4 m-x-5 m-cols-2    l-y-2 l-x-5 l-cols-2"
                                                : 
                                                    "s-y-5 s-x-1 s-cols-2    m-y-2 m-x-5 m-cols-2    l-y-2 l-x-5 l-cols-2"}`}
                                        >
                                            <div className={ classes.wrapper }>
                                                <FormControl  className={ classes.formControl } 
                                                fullWidth
                                                size="small"
                                                id="distrito"
                                                name="distrito"
                                                variant="outlined"
                                                error={ touched.distrito && Boolean( errors.distrito ) }
                                                >
                                                    <InputLabel id="distrito-label" className={ classes.selectStyle} >
                                                        Distrito
                                                    </InputLabel>
                                                    <Select  className={ classes.selectStyle} 
                                                    labelId="distrito-label"
                                                    label="Distrito"
                                                    value={ values.distrito }
                                                    onBlur={ handleBlur( 'distrito' ) }
                                                    disabled={ distritos.isLoading }
                                                    onChange={ e => {
                                                        const { value } = e.target
                                                                
                                                        if ( !value ) {
                                                            dispatch( resetInstituciones() )
                                                            setFieldValue( "distrito", '' )
                                                            dispatch( resetMunicipalidades() )
                                                        }
                                                        else {
                                                            dispatch( getInstitucionesBD( values.region, values.provincia, value, 
                                                                values.nivel, values.tipo_inst_edu,
                                                                (informacion_basica.cargo == '007' ? '0' : '1') ) )
                                                            setFieldValue( "distrito", value )
                                                            dispatch( getMunicipalidadesBD( values.region, values.provincia, value, 'no' ) )
                                                        }
                                                        setFieldValue("inst_educativa", '')
                                                        setFieldValue( 'formato', '' )
                                                        
                                                        formatos.listado.forEach(element => {
                                                            element.HABILITADO = false;
                                                        });

                                                    } }
                                                    >
                                                    {
                                                        distritos.listado.length === 0
                                                        ?
                                                            <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                        :
                                                            distritos.listado.map( ( opt, i) => (
                                                                <MenuItem  className={ classes.selectStyle} key={ i } value={ opt.DISTRITO_COD }>{ opt.DISTRITO_DES }</MenuItem>
                                                            ) )
                                                    }
                                                    </Select>
                                                    {
                                                        touched.distrito
                                                        ? <FormHelperText className={ classes.selectStyle} >{ errors.distrito }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                                { distritos.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                            </div>
                                        </div>
                                        <div className={`${informacion_basica.cargo == '007'
                                                ? 
                                                    "s-y-9 s-x-1 s-cols-2    m-y-5 m-x-1 m-cols-6    l-y-2 l-x-7 l-cols-6"
                                                : 
                                                    "s-y-6 s-x-1 s-cols-2    m-y-3 m-x-1 m-cols-6    l-y-2 l-x-7 l-cols-6"}`}
                                        >
                                            <div className={ classes.wrapper }>
                                                <FormControl  className={ classes.formControl } 
                                                fullWidth
                                                size="small"
                                                id="inst_educativa"
                                                name="inst_educativa"
                                                variant="outlined"
                                                error={ touched.inst_educativa && Boolean( errors.inst_educativa ) }
                                                >
                                                    <InputLabel id="ie-label" className={ classes.selectStyle} >
                                                        Institución Educativa
                                                    </InputLabel>
                                                    <Select  className={ classes.selectStyle} 
                                                    labelId="ie-label"
                                                    label="Institución Educativa"
                                                    value={ values.inst_educativa }
                                                    onBlur={ handleBlur( 'inst_educativa' ) }
                                                    disabled={ instituciones.isLoading }
                                                    onChange={ e => {
                                                        const { value } = e.target
                                                        // setFieldValue( 'formato', '' )
                                                        instituciones.listado.forEach(element => {
                                                            if (element.CUI === value) {
                                                                setFieldValue( "direccion_ie", element.DIRECCION )
                                                                setFieldValue( "latitud_ie", element.LATITUD )
                                                                setFieldValue( "longitud_ie", element.LONGITUD )
                                                                setFieldValue( "indicador_ubicacion", '0' );
                                                                setFieldValue( "indicador_coordenadas", '0' );
                                                                
                                                                dispatch( setCoordenadas({
                                                                    ubicacion_ie: { lat: element.LATITUD, lng: element.LONGITUD }
                                                                } ) )

                                                            }
                                                        });

                                                        // dispatch( getPreguntasBD() )
                                                        isComplete = false;
                                                        localStorage.removeItem('id_formato_selected'); 
                                                        
                                                        if ( !value ) {
                                                            setFieldValue( "inst_educativa", '' )
                                                            formatos.listado.forEach(element => {
                                                                element.HABILITADO = false;
                                                            });
                                                            // if ( formatos.listado.length > 0 )
                                                            // {
                                                            //     formatos.listado[0].SELECTED = false;
                                                            // }
                                                        }
                                                        else {
                                                           setFieldValue( "inst_educativa", value )
                                                           formatos.listado.forEach(element => {
                                                                element.HABILITADO = true;
                                                            });

                                                            dispatch( obtenerFormatos( { dni: (informacion_basica.cargo == '007' ? values.dni : padre.dni),
                                                                                        tipo_doc_hijo: values.tipo_doc_hijo,
                                                                                        region: values.region,
                                                                                        tipo_inst_edu: values.tipo_inst_edu,
                                                                                        cargo: informacion_basica.cargo,
                                                                                        inst_educativa: value,
                                                                                        lista_formato: formatos.listado } ) )
                                                                                       
                                                               
                                                            setFieldValue( 'formato', '' )
                                                            formatos.listado.forEach(element => {
                                                                element.HABILITADO = false;
                                                            }); 
                                                         
                                                             if ( formatos.listado.length > 0 )
                                                             {
                                                                 formatos.listado[0].SELECTED = true;
                                                                 setFieldValue( 'formato', [ formatos.listado[0] ] )
                                                             }
                                                        }

                                                    } }
                                                    >
                                                    {
                                                        instituciones.listado.length === 0
                                                        ?
                                                            <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                        :
                                                            instituciones.listado.map( ( opt, i) => (
                                                                <MenuItem  className={ classes.selectStyle} key={ i } value={ opt.CUI }>{ opt.IE_DES }</MenuItem>
                                                            ) )
                                                    }
                                                    </Select>
                                                    {
                                                        touched.inst_educativa
                                                        ? <FormHelperText className={ classes.selectStyle} >{ errors.inst_educativa }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                                { instituciones.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                                {
                                                    values.inst_educativa
                                                    ? <FormHelperText className={ classes.selectStyle} >{ 'DIRECCIÓN: ' + values.direccion_ie }</FormHelperText>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </AccordionDetails>
    
                            </Accordion>
                        }
                    </div>
                    {/* Fin: Institucion Educativa */}
                    {/*

                    <Button variant="contained" size="large"    className={ classes.buttonStyle } visible={false}

                                            type="submit"
                                            onClick={ e => {

                                                setexpandedFormato( true ) 

                                                {veeduria.message = ''}

                                                formatos.listado.forEach(element => {
                                                    element.HABILITADO = true;                                
                                                });

                                         dispatch( validarDNI( { dni: values.dni, tipo_doc_hijo: values.tipo_doc_hijo, lista_formato: formatos.listado } ) );


                                                console.log('values.dni..', values.dni);  
                                                console.log('lista_formato...', formatos.listado);  

                                               localStorage.removeItem('id_formato_selected'); 
                                             
                                               dispatch( obtenerFormatos( { dni: values.dni,
                                                                            tipo_doc_hijo: values.tipo_doc_hijo,
                                                                            region: values.region,
                                                                            tipo_inst_edu: values.tipo_inst_edu,
                                                                            cargo: informacion_basica.cargo,
                                                                            inst_educativa: values.inst_educativa,
                                                                            lista_formato: formatos.listado } ) )
                                                                          
                                                                            console.log('cargo: informacion_basica.cargo ', informacion_basica.cargo);  
                                              setFieldValue( 'formato', '' )

                                                
                                                
                                                formatos.listado.forEach(element => {
                                                    element.HABILITADO = false;
                                                }); 
                                                dispatch( getPreguntasBD( 0 ) )
                                                setFieldValue( "autorizacion", '' )


                                              

                                                // agregado 21.07.2025
                                                if ( formatos.listado.length > 0 )
                                                        {
                                                            formatos.listado[0].SELECTED = true;
                                                            setFieldValue( 'formato', [ formatos.listado[0] ] )
                                                        }
                                                // fin agregado 21.07.2025

                                            
                                             console.log('veeduria.message : ', veeduria.message );
                                            } 
                                           
                                            }
                                            color="secondary" startIcon={ <AddIcon /> } >
                                                Nueva veeduría...
                                                
                    </Button>

                    // solo veeduría simultánea
                    */} 

{/* 
                    <Button variant="contained" size="large"    className={ classes.buttonStyle } visible={false}

                                            type="submit"
                                            onClick={ e => {

                                                window.location.reload();
                                            } 
                                           
                                            }
                                            color="primary" startIcon={ <CloseIcon/> } >
                                               

                                              Concluir
                                                
                    </Button>
                    // solo para veedurías simultáneas 
                       */}         


                    {/* Inicio: Formato */}
                    <div>    
                        {
                            ((!errors.dni && values.dni !== '' && values.inst_educativa !== '' && informacion_basica.cargo == '007') || 
                            (values.inst_educativa !== '' && informacion_basica.cargo != '007'))
                            && 
                            <Accordion expanded={ expandedFormato } id="acordionFormato" onChange={ () => { setexpandedFormato( !expandedFormato ) } }
                            disabled={padre.severity !== 'success'} style={{ marginTop: "12px" }} >
                                <StyledAccordionSummary aria-controls="panel2a-content" id="panel2a-header"
                                expandIcon={ <ExpandMoreIcon className={ classes.iconExpander }/> } >
                                    {
                                        (informacion_basica.cargo == '007')
                                        ?
                                            <Typography className={ classes.heading }>
                                                Selecciona la Veeduría Escolar en la que participarás
                                            </Typography>
                                        :
                                            <Typography className={ classes.heading }>
                                                Veeduría Escolar
                                            </Typography>
                                    }
                                </StyledAccordionSummary>
                                <AccordionDetails className={ classes.detalle }>
                                    
                                    <div className="ed-grid rows-gap s-gap-3 m-gap-3 l-gap-3 s-grid-2 m-grid-6 lg-grid-12">
    
                                        <div className="s-y-1 s-x-1 s-cols-2
                                                        m-y-1 m-x-1 m-cols-6
                                                        l-y-1 l-x-1 l-cols-12">
                                            {/* https://stackblitz.com/edit/formik-checkbox-radio?file=index.tsx */}
                                            {
                                                (values.inst_educativa !== '' && !estudiante.isLoading)
                                                && 
                                                <FormControl component="fieldset" 
                                                className={ classes.formControl }
                                                error={ touched.formato && Boolean( errors.formato ) } >
                                                    
                                                <RadioGroup row name="FORMATOS"  className={ classes.radioStyle }



                                                    /*CheckGroup*/
                                                    
                                                  onChange={ ( e, value ) => {
                                                        setFieldValue( 'formato', value )  
                                                      
                                                        localStorage.setItem('id_formato_selected', value);
                                    
                                                       veeduria.message = '';
                                                                                                        
                                                        
                                                        
                                                        if(informacion_basica.cargo != '007') {
                                                            setFieldValue( 'nivel', 'S' )
                                                            setFieldValue( 'tipo_doc_hijo', '0101' )
                                                            setFieldValue( 'nacionalidad', 'xx' )
                                                            setFieldValue( 'dni', '12345678' )
                                                            setFieldValue( 'nombre', 'xx' )
                                                            setFieldValue( 'apellido_paterno', 'xx' )
                                                            setFieldValue( 'apellido_materno', 'xx' )
                                                            setFieldValue( 'genero', 'xx' )
                                                            setFieldValue( 'grado', 'xx' )
                                                            setFieldValue( 'seccion', 'xx' )
                                                        }

                                                  

                                                        dispatch( getPreguntasBD( value ) )
                                                        formatos.listado.forEach(element => {
                                                            if (element.FORMATO_COD === value) {
                                                                
                                                                localStorage.setItem('nombre_formato_vee', element.FORMATO_DES);
                                                 
                                                                setFieldValue( "indicador_ubicacion", element.IND_UBICACION );
                                                                setFieldValue( "indicador_coordenadas", element.IND_COORDENADAS );
                                                                setFieldValue( 'formato_des', element.FORMATO_DES ) 
                                                  


                                                                if (element.IND_UBICACION === '1') {
                                                                    dispatch( getRegionesMuniBD() )
                                                                    setFieldValue("region_muni", values.region)
                                                                    dispatch( getProvinciasMuniBD( values.region ) )
                                                                    dispatch( resetDistritosMuni() )
                                                                    // dispatch( resetMunicipalidades() )
                                                                    // setFieldValue("provincia_muni", '')
                                                                    // setFieldValue("distrito_muni", '')
                                                                    setFieldValue("municipalidad", '')
                                                                    setFieldValue("provincia_muni", values.provincia)
                                                                    dispatch( getDistritosMuniBD( values.region, values.provincia ) )
                                                                    setFieldValue("distrito_muni", values.distrito)
                                                                    // dispatch( getMunicipalidadesBD( values.region_muni, values.provincia_muni, values.distrito, 'no' ) )
                                                                }

                                                                if (element.IND_COORDENADAS === '1') {
                                                                    // Inicio: Obtiene ubicación del usuario
                                                                    if (navigator.geolocation) 
                                                                    {
                                                                        navigator.geolocation.getCurrentPosition((position) => {
                                                                            setFieldValue("latitud_user", position.coords.latitude)
                                                                            setFieldValue("longitud_user", position.coords.longitude)
                                                                            console.log('Latitude is :', position.coords.latitude);
                                                                            console.log('Longitude is :', position.coords.longitude);
                                                                            
                                                                            dispatch( setCoordenadas({
                                                                                ubicacion_user: { lat: position.coords.latitude, lng: position.coords.longitude }
                                                                            } ) )
                                                                        });
                                                                    }
                                                                    // else {
                                                                    //     debugger;
                                                                    //     alert('position.coords.latitude')
                                                                    //     setFieldValue( "latitud_user", null )
                                                                    //     setFieldValue( "longitud_user", null )
                                                                    //     console.log('Latitude no :');
                                                                    // }
                                                                    // Inicio: Obtiene ubicación del usuario
                                                                }
                                                            }
                                                        });
                                                        
                                                    } }
                                                    >
                                                        {
                                                            informacion_basica.cargo == '001'
                                                            ?
                                                                formatos.listado.map( formato => (
                                                                    formato.FORMATO_DES == 'PROGRAMA DE MANTENIMIENTO EN LAS INSTITUCIONES EDUCATIVAS - 2024'
                                                                    && (
                                                                        formato.SELECTED
                                                                        ?
                                                                            <FormControlLabel value={ formato.FORMATO_COD } 
                                                                            disabled
                                                                            name={ formato.FORMATO_COD }
                                                                            control={ <Radio color="primary" /> } 
                                                                            label={ formato.FORMATO_DES } />
                                                                        :
                                                                            <FormControlLabel value={ formato.FORMATO_COD } 
                                                                            disabled={ !formato.HABILITADO }
                                                                            name={ formato.FORMATO_COD }
                                                                            control={ <Radio color="primary" /> } 
                                                                            label={ formato.FORMATO_DES } />
                                                                    )
                                                                ) )
                                                            :
                                                                formatos.listado.map( formato => (
                                                                    formato.FORMATO_DES != 'PROGRAMA DE MANTENIMIENTO EN LAS INSTITUCIONES EDUCATIVAS - 2024'
                                                                    && (
                                                                        formato.SELECTED
                                                                        ?
                                                                            <FormControlLabel value={ formato.FORMATO_COD } 
                                                                            disabled
                                                                            name={ formato.FORMATO_COD }
                                                                            control={ <Radio color="primary" /> } 
                                                                            label={ formato.FORMATO_DES } />
                                                                        :
                                                                            <FormControlLabel value={ formato.FORMATO_COD } 
                                                                            disabled={ !formato.HABILITADO }
                                                                            name={ formato.FORMATO_COD }
                                                                            control={ <Radio color="primary" /> } 
                                                                            label={ formato.FORMATO_DES } />
                                                                    )
                                                                )  )
                                                                
                                                        }
                                                    </RadioGroup>
                                                    {
                                                        touched.formato
                                                        ? <FormHelperText className={ classes.radioStyle } >{ errors.formato }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                            }
    
    
    
                                                {/* <FormLabel component="legend">Formato</FormLabel> */}
                                            {/* <FormControl component="fieldset"
                                            className={ classes.formControl }
                                            value={ values.formato }
                                            onBlur={ handleBlur( 'formato' ) }
                                            error={ touched.formato && Boolean( errors.formato ) } >
                                                <FormGroup row>
                                                    {
                                                        formatos.listado.map( formato => (
                                                            <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    options={ formato }
                                                                    id={ formato.FORMATO_COD }
                                                                    name={ formato.FORMATO_COD }
                                                                    checked={ formato.SELECTED }
                                                                    disabled
                                                                    onChange={ ( e, value ) => {
                                                                        const groups = values.formato
                                                                        formato.SELECTED = value;
                                                                        if ( value ) {
                                                                            if ( groups ) {
                                                                                setFieldValue( 'formato', [ formato.FORMATO_COD, ...groups ] )
                                                                            }
                                                                            else {
                                                                                setFieldValue( 'formato', [ formato.FORMATO_COD ] )
                                                                            }
                                                                        }
                                                                        else{
                                                                            setFieldValue( 'formato', groups.filter( note => note !== formato.FORMATO_COD ) )
                                                                        }
                                                                    } }
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={ formato.FORMATO_DES }
                                                            />
                                                        ) )
                                                    }
                                                </FormGroup>
                                                {
                                                    touched.formato
                                                    ? <FormHelperText>{ errors.formato }</FormHelperText>
                                                    : null
                                                }
                                            </FormControl> */}
    
                                        </div>
    
    
                                        {
                                            values.indicador_ubicacion == '1' && values.inst_educativa !== '' && localStorage.getItem('id_formato_selected') != null
                                            &&
                                                <div className="s-y-2 s-x-1 s-cols-2
                                                                m-y-2 m-x-1 m-cols-6
                                                                l-y-2 l-x-1 l-cols-12">
                                                    {/* Inicio: Ubicación del barrio */}
                                                    
                                                    {/* <Typography className={ classes.heading } style={{ fontWeight: '600'}}>
                                                        Recuerda que las observaciones las efectúas sobre tu comunidad
                                                    </Typography> */}
                                                    <a id="ancla_municipalidad"></a>
                                                    <Accordion square expanded>
                                                        <AccordionEstSummary aria-controls="panel1d-content" id="grupo_cero">
                                                            <Typography>Indícanos tu municipalidad:</Typography>
                                                        </AccordionEstSummary>
    
    
                                                        <StyledAccordionDetails>
                                                                    {/* <MapContainer /> */}
                                                            <div className="ed-grid rows-gap s-gap-3 m-gap-3 l-gap-3 s-grid-2 m-grid-6 lg-grid-12">
                                                                <div className="s-y-1 s-x-1 s-cols-2 
                                                                                m-y-1 m-x-1 m-cols-2
                                                                                l-y-1 l-x-1 l-cols-2">
                                                                    <div className={ classes.wrapper }>
                                                                        <FormControl  className={ classes.selectStyle } 
                                                                        fullWidth
                                                                        size="small"
                                                                        id="region_muni"
                                                                        name="region_muni"
                                                                        variant="outlined"
                                                                        error={ touched.region_muni && Boolean( errors.region_muni ) }
                                                                        >
                                                                            <InputLabel id="region_muni-label" className={ classes.selectStyle} >
                                                                                Región
                                                                            </InputLabel>
                                                                            <Select  className={ classes.selectStyle } 
                                                                            labelId="region_muni-label"
                                                                            id="region_muni-select-outlined"
                                                                            label="Región"
                                                                            value={ values.region_muni }
                                                                            onBlur={ handleBlur( 'region_muni' ) }
                                                                            disabled
                                                                            onChange={ e => {
                                                                                const { value } = e.target
                                                                                
                                                                                if ( !value ) {
                                                                                    dispatch( resetProvinciasMuni() )
                                                                                    setFieldValue("region_muni", '')
                                                                                }
                                                                                else{
                                                                                    dispatch( getProvinciasMuniBD( value ) )
                                                                                    setFieldValue("region_muni", value)
                                                                                }
                                                                                
                                                                                dispatch( resetDistritosMuni() )
                                                                                dispatch( resetMunicipalidades() )
                                                                                setFieldValue("provincia_muni", '')
                                                                                setFieldValue("distrito_muni", '')
                                                                                setFieldValue("municipalidad", '')
                                                                                
                                                                            } }
                                                                            >
                                                                            {
                                                                                regionesMuni.listado.length === 0
                                                                                ?
                                                                                    <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                                                :
                                                                                    regionesMuni.listado.map( ( opt, i) => (
                                                                                        <MenuItem  className={ classes.selectStyle }  key={ i } value={ opt.REGION_COD }>{ opt.REGION_DES }</MenuItem>
                                                                                    ) )
                                                                            }
                                                                            </Select>
                                                                            {
                                                                                touched.region_muni
                                                                                ? <FormHelperText  className={ classes.selectStyle } >{ errors.region_muni }</FormHelperText>
                                                                                : null
                                                                            }
                                                                        </FormControl>
                                                                        { regionesMuni.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                                                    </div>
                                                                </div>
                                                                <div className="s-y-2 s-x-1 s-cols-2
                                                                                m-y-1 m-x-3 m-cols-2
                                                                                l-y-1 l-x-3 l-cols-2">
                                                                    <div className={ classes.wrapper }>
                                                                        <FormControl  className={ classes.selectStyle } 
                                                                        fullWidth
                                                                        size="small"
                                                                        id="provincia_muni"
                                                                        name="provincia_muni"
                                                                        variant="outlined"
                                                                        error={ touched.provincia_muni && Boolean( errors.provincia_muni ) }
                                                                        >
                                                                            <InputLabel  id="provincia-muni-label" className={ classes.selectStyle} >
                                                                                Provincia
                                                                            </InputLabel>
                                                                            <Select  className={ classes.selectStyle } 
                                                                            labelId="provincia-muni-label"
                                                                            id="provincia-muni-select-outlined"
                                                                            label="Provincia"
                                                                            value={ values.provincia_muni }
                                                                            onBlur={ handleBlur( 'provincia_muni' ) }
                                                                            // disabled={ provinciasMuni.isLoading }
                                                                            disabled
                                                                            onChange={ e => {
                                                                                const { value } = e.target
            
                                                                                if ( !value ) {
                                                                                    dispatch( resetDistritosMuni() )
                                                                                    setFieldValue( "provincia_muni", '' )
                                                                                }
                                                                                else {
                                                                                    dispatch( getDistritosMuniBD( values.region_muni, value ) )
                                                                                    setFieldValue( "provincia_muni", value )
                                                                                }
                                                                                dispatch( resetMunicipalidades() )
                                                                                setFieldValue("distrito_muni", '')
                                                                                setFieldValue("municipalidad", '')
            
                                                                            } }
                                                                            >
                                                                            {
                                                                                provinciasMuni.listado.length === 0
                                                                                ?
                                                                                    <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                                                :
                                                                                    provinciasMuni.listado.map( ( opt, i) => (
                                                                                        <MenuItem  className={ classes.selectStyle }  key={ i } value={ opt.PROVINCIA_COD }>{ opt.PROVINCIA_DES }</MenuItem>
                                                                                    ) )
                                                                            }
                                                                            </Select>
                                                                            {
                                                                                touched.provincia_muni
                                                                                ? <FormHelperText  className={ classes.selectStyle } >{ errors.provincia_muni }</FormHelperText>
                                                                                : null
                                                                            }
                                                                        </FormControl>
                                                                        { provinciasMuni.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                                                    </div>
                                                                </div>
                                                                <div className="s-y-3 s-x-1 s-cols-2
                                                                                m-y-1 m-x-5 m-cols-2
                                                                                l-y-1 l-x-5 l-cols-2">
                                                                    <div className={ classes.wrapper }>
                                                                        <FormControl  className={ classes.selectStyle } 
                                                                        fullWidth
                                                                        size="small"
                                                                        id="distrito_muni"
                                                                        name="distrito_muni"
                                                                        variant="outlined"
                                                                        error={ touched.distrito_muni && Boolean( errors.distrito_muni ) }
                                                                        >
                                                                            <InputLabel id="distrito-muni-label" className={ classes.selectStyle} >
                                                                                Distrito
                                                                            </InputLabel>
                                                                            <Select  className={ classes.selectStyle } 
                                                                            labelId="distrito-muni-label"
                                                                            id="distrito-muni-select-outlined"
                                                                            label="Distrito"
                                                                            value={ values.distrito_muni }
                                                                            onBlur={ handleBlur( 'distrito_muni' ) }
                                                                            // disabled={ distritosMuni.isLoading }
                                                                            disabled
                                                                            onChange={ e => {
                                                                                const { value } = e.target
                                                                                        
                                                                                if ( !value ) {
                                                                                    dispatch( resetMunicipalidades() )
                                                                                    setFieldValue( "distrito_muni", '' )
                                                                                }
                                                                                else {
                                                                                    dispatch( getMunicipalidadesBD( values.region_muni, values.provincia_muni, value, 'no' ) )
                                                                                    setFieldValue( "distrito_muni", value )
                                                                                }
                                                                                setFieldValue("municipalidad", '')
                                                                                setFieldValue("existe_observacion", existe_observacion)
                                                                                
                                                                            } }
                                                                            >
                                                                            {
                                                                                distritosMuni.listado.length === 0
                                                                                ?
                                                                                    <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                                                :
                                                                                    distritosMuni.listado.map( ( opt, i) => (
                                                                                        <MenuItem   className={ classes.selectStyle } key={ i } value={ opt.DISTRITO_COD }>{ opt.DISTRITO_DES }</MenuItem>
                                                                                    ) )
                                                                            }
                                                                            </Select>
                                                                            {
                                                                                touched.distrito_muni
                                                                                ? <FormHelperText  className={ classes.selectStyle }  >{ errors.distrito_muni }</FormHelperText>
                                                                                : null
                                                                            }
                                                                        </FormControl>
                                                                        { distritosMuni.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                                                    </div>
                                                                </div>
                                                                
                                                                <div className="s-y-4 s-x-1 s-cols-2
                                                                                m-y-2 m-x-1 m-cols-6
                                                                                l-y-1 l-x-7 l-cols-6">
                                                                    <div className={ classes.wrapper }>
                                                                        <FormControl
                                                                        fullWidth
                                                                        size="small"
                                                                        id="municipalidad"
                                                                        name="municipalidad"
                                                                        variant="outlined"
                                                                        error={ touched.municipalidad && Boolean( errors.municipalidad ) }
                                                                        >
                                                                            <InputLabel id="municipalidad-label" className={ classes.selectStyle} >
                                                                                Municipalidad
                                                                            </InputLabel>
                                                                            <Select
                                                                            labelId="municipalidad-label"
                                                                            id="municipalidad-select-outlined"
                                                                            label="Municipalidad"
                                                                            value={ values.municipalidad }
                                                                            onBlur={ handleBlur( 'municipalidad' ) }
                                                                            disabled={ municipalidades.isLoading }
                                                                            onChange={ e => {
                                                                                const { value } = e.target
                                                                                
                                                                                if ( !value ) {
                                                                                    setFieldValue( "municipalidad", '' )
                                                                                }
                                                                                else {
                                                                                    setFieldValue( "municipalidad", value )
                                                                                }

                                                                            } }
                                                                            >
                                                                            {
                                                                                municipalidades.listado.map( ( opt, i) => (
                                                                                    <MenuItem key={ i } value={ opt.MUNICIPALIDAD_COD }>{ opt.MUNICIPALIDAD_DES }</MenuItem>
                                                                                ) )
                                                                            }
                                                                            </Select>
                                                                            {
                                                                                touched.municipalidad
                                                                                ? <FormHelperText>{ errors.municipalidad }</FormHelperText>
                                                                                : null
                                                                            }
                                                                        </FormControl>
                                                                        { municipalidades.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                                                    </div>

                                                                    { <div className={ classes.wrapper }>
                                                                        <TextField className={ classes.inputStyle} 
                                                                        fullWidth 
                                                                        size="small"
                                                                        label="Referencia" 
                                                                        name="referencia_muni"
                                                                        autoComplete="none"
                                                                        variant="outlined"
                                                                        value={ values.referencia_muni }
                                                                        onBlur={ handleBlur }
                                                                        helperText="Urb/AAHH/Asociación/Cooperativa/Km., u otro dato que nos permita saber la ubicación de la zona de observación."
                                                                        // helperText={ touched.referencia_muni ? errors.referencia_muni : "Urb/AAHH/Asociación/Cooperativa/Km., u otro dato que nos permita saber la ubicación de la zona de observación."}
                                                                        error={ touched.referencia_muni && Boolean( errors.referencia_muni ) }
                                                                        inputProps={ { maxLength: 500 } }
                                                                        onChange={(event) => {
                                                                            const regex = /^([a-z0-9ñáéíóú ]+)$/i;
                                                                            if (event.target.value === '' || regex.test(event.target.value)) {
                                                                                setFieldValue("referencia_muni", event.target.value);
                                                                            }
                                                                        }}
                                                                        />
                                                                    </div> }
                                                                </div>

                                                                {
                                                                    values.indicador_coordenadas == '1'
                                                                    &&
                                                                    <>
                                                                        <div className="s-y-5 s-x-1 s-cols-2 
                                                                                        m-y-3 m-x-1 m-cols-2
                                                                                        l-y-2 l-x-1 l-cols-2">
                                                                            <Button variant="outlined" fullWidth color={ ubicacion.lat == 0 ? 'secondary' : 'primary' } onClick={handleClickOpenMap}>
                                                                                Seleccione ubicación
                                                                            </Button>
                                                                            <MapControl open = { openMap }
                                                                            handleClose = { handleCloseMap }
                                                                            handleGuardar = { handleGuardarPoint }
                                                                            latitud_ie = { values.latitud_ie }
                                                                            longitud_ie = { values.longitud_ie }
                                                                            latitud_user = { values.latitud_user }
                                                                            longitud_user = { values.longitud_user }
                                                                            coordenadas = { ubicacion }/>
                                                                        </div>
                                                                        <div className="s-y-6 s-x-1 s-cols-2
                                                                                        m-y-3 m-x-3 m-cols-4
                                                                                        l-y-2 l-x-3 l-cols-4">
                                                                            <div className={ classes.wrapper }>
                                                                                <TextField className={ classes.inputStyle} 
                                                                                fullWidth 
                                                                                size="small"
                                                                                label="Dirección"
                                                                                disabled
                                                                                name="referencia_mapa"
                                                                                autoComplete="none"
                                                                                variant="outlined"
                                                                                value={ referencia_mapa }
                                                                                helperText= 'Referencia aproximada, brindada por google maps'
                                                                                inputProps={ { maxLength: 300 } }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                        </StyledAccordionDetails>
    
    
                                                    </Accordion>
                                                    {/* Fin: Ubicación del barrio */}




                                                </div>
                                        }
    
    
    

                                        <div className={`${values.indicador_ubicacion == '1' ? 's-y-3 s-x-1 s-cols-2 m-y-3 m-x-1 m-cols-6 l-y-3 l-x-1 l-cols-12' : 's-y-2 s-x-1 s-cols-2 m-y-2 m-x-1 m-cols-6 l-y-2 l-x-1 l-cols-12'}`}>
                                            {
                                                values.inst_educativa !== '' && localStorage.getItem('id_formato_selected') != null
                                                && 
                                                <>
                                                    {/* LÓGICA: VARIAS VEEDURÍAS */}
                                                    {/*
                                                        (informacion_basica.cargo == '007')
                                                        &&
                                                        <div>
                                                            <Card style={{ padding: '10px 20px', textAlign: 'center'}}>
                                                                <CardContent>
                                                                   
                                                                    <Typography gutterBottom variant="h6" component="div">
                                                                        VEEDURÍA ESCOLAR: {values.formato_des}
                                                                    </Typography>
                                                                    {
                                                                        values.formato_des == 'PLAN LECTOR1'
                                                                        &&
                                                                        <Typography variant="body2" color="text.secondary" style={{color: 'gray'}}>
                                                                            - Ley N° 28044, Ley General de Educación<br/>
                                                                            - Ley N° 31053 que reconoce y fomenta el derecho a la lectura y promueve el libro<br/>
                                                                            - DS. 018-2021-MC - Reglamento de la Ley N° 31053<br/>
                                                                            - Resolución Directoral Nacional N° 234-2005-BNP, Normas para bibliotecas escolares<br/>
                                                                            - RVM N° 062-2021-MINEDU Documento normativo que aprueba "Disposiciones para la organización e implementación del Plan Lector en las Instituciones Educativas y Programas educativos de la Educación Básica"
                                                                        </Typography>
                                                                    }
                                                                    {
                                                                        values.formato_des == 'GESTIÓN DE RIESGOS 2024'
                                                                        &&
                                                                        <Typography variant="body2" color="text.secondary" style={{color: 'gray'}}>
                                                                            - Ley N° 29664, Ley que crea el Sistema Nacional de Gestión de Riesgo de Desastres (SINAGERD)<br/>
                                                                            - Decreto Supremo que aprueba el Reglamento de la Ley N° 29664, que crea el Sistema Nacional de Gestión del Riesgo de Desastres (SINAGERD)<br/>
                                                                            - Resolución de Secretaría General N° 302-2019-MINEDU de 24.12.2019 – NT "Disposiciones para la implementación de la Gestión del Riesgo de Emergencias y Desastres en el SectorEducación"<br/>
                                                                            - Resolución Ministerial N° 189-2021-MINEDU de 06.05.2021 – "Disposiciones para los Comité de Gestión Escolar en las Instituciones Educativas Públicas de Educación Básica"<br/>
                                                                            - Directiva N° D0000002-2022-INDECI-SEC GRAL - "Organización, Ejecución y Evaluación de Simulacros Nacionales Multipeligro para los Años 2022 - 2024"<br/>
                                                                            - Lineamientos para la ejecución del Simulacro Nacional Multipeligro 2023-2024
                                                                        </Typography>
                                                                    }
                                                                    {
                                                                        values.formato_des == 'QUIOSCOS Y CAFETERÍAS EN LAS II.EE 2024'
                                                                        &&
                                                                        <Typography variant="body2" color="text.secondary" style={{color: 'gray'}}>
                                                                            - Ley N° 30021, "Ley de promoción de la alimentación saludable para niños, niñas y adolescentes" y su Reglamento vigente.<br/>
                                                                            - Decreto Supremo Nº 017-2017-SA - Reglamento de la Ley Nº 30021, Ley de Promoción de la Alimentación Saludable:<br/>
                                                                            - Resolución Ministerial N° 195-2019-MINSA "Documento Técnico: Lineamientos para la Promoción y Protección de la Alimentación Saludable en las Instituciones Educativas Públicas y Privadas de la Educación Básica"<br/>
                                                                            - Resolución Viceministerial N° 054-2021-MINEDU: NT "Criterios de Diseño para Ambientes de Servicios de Alimentación en los Locales Educativos de la Educación Básica".<br/>
                                                                            - Resolución Ministerial N° 033-2020/MINSA, "Criterios de evaluación a quiosco, cafeterías y comedores escolares en instituciones educativas de educación básica regular públicas y privadas para una alimentación saludable".<br/>
                                                                            - Resolución de Secretaría General N° 302-2019-MINEDU de 24.12.2019 – Norma Técnica denominada "Disposiciones para la implementación de la Gestión del Riesgo de Emergencias y Desastres en el Sector Educación"
                                                                        </Typography>
                                                                    }
                                                                    {
                                                                        (values.formato_des == 'PROGRAMA DE MANTENIMIENTO EN LAS INSTITUCIONES EDUCATIVAS - 2024' ||
                                                                        values.formato_des == 'PROGRAMA DE MANTENIMIENTO EN LAS INSTITUCIONES EDUCATIVAS 2024')
                                                                        &&
                                                                        <Typography variant="body2" color="text.secondary" style={{color: 'gray'}}>
                                                                        - Ley N° 28044 - Ley General de Educación<br/>
                                                                        - D.S N° 011-2012-ED, Reglamento de la Ley N° 28044, Ley General de Educación<br/>
                                                                        - DS Nº 004-2014-MINEDU, Programa Nacional de Infraestructura Educativa (PRONIED)<br/>
                                                                        - RM N° 557-2020-MINEDU, NT "Disposiciones generales para la ejecución de mantenimiento y acondicionamiento de infraestructura educativa bajo la modalidad de subvenciones"<br/>
                                                                        - RM Nº 679-2023-MINEDU,NT "Disposiciones para la ejecución del Programa de Mantenimiento para el año 2024"<br/>
                                                                        - RVM N° 010-2022-MINEDU, NT "Criterios Generales de Diseño para Infraestructura Educativa"<br/>
                                                                        - Ley Nº 31953 -Ley de Presupuesto del Sector Público para el Año Fiscal 2024.
                                                                        - Resolución Directoral Ejecutiva N° 000002-2024-MINEDU-VMGI-PRONIED-DE, mediante la cual se aprueba el "Listado de Locales Educativos beneficiarios del Programa de Mantenimiento para el año 2024".
                                                                        </Typography>
                                                                    }
                                                                </CardContent>
                                                            </Card>
                                                        </div>
                                                      */  }
                                                    {/* LÓGICA: VARIAS VEEDURÍAS */}
                                                    <FormatoScreen/>
                                                    

                                                    <div style={{display: 'flex', marginTop: '50px'}}>
                                                        <FormControlLabel
                                                            control={
                                                            <Checkbox
                                                                checked={ values.autorizacion }
                                                                // checked={state.checkedAUTORIZACION}
                                                                // onChange={handleChangeAUTORIZACION}
                                                                id="autorizacion"
                                                                name="autorizacion"
                                                                color="primary"
                                                                onChange={ e => {
                                                                    const { checked } = e.target
                                                                    console.log('autorizacion:', checked)
                
                                                                    if (checked)
                                                                        setFieldValue( "autorizacion", '1' )
                                                                    else
                                                                        setFieldValue( "autorizacion", '' )
                
                                                                } }
                                                            />
                                                            }
                                                        />




                                                        <span className="text">
                                                            <strong>
                                                                Declaro haber leído el siguiente contenido correspondiente a los Principios de "La Reserva" y de "Participación Ciudadana" que rige al Control Gubernamental y a las actividades del Programa "Auditores Juveniles".
                                                            </strong>
                                                            {showMore && (
                                                            <>
                                                                <p></p>
                                                                El Programa <strong>"Auditores Juveniles"</strong> rige sus actividades que son promovidas sobre la base del Convenio 152 - 2019 – MINEDU - Convenio de Cooperación Interinstitucional entre el Ministerio de Educación y la Contraloría General de la República del Perú suscrito el 03 de diciembre de 2019.
                                                                <p></p>
                                                                Asimismo, en el marco del literal "n" y "q" art. 9 de la Ley 27785 – Ley del Sistema Nacional de Control y de la Contraloría General de la República, respecto a los principios establece lo siguiente: <strong>"La Reserva"</strong>, por cuyo mérito se encuentra prohibido que durante la ejecución del control se revele información que pueda causar daño a la entidad, a su personal o al sistema, o dificulte la tarea de este último” y de <strong>"Participación Ciudadana"</strong> que permite la contribución de la ciudadanía en el ejercicio del control gubernamental.
                                                                <p></p>
                                                                En ese sentido, mediante la presente declaración <strong>se autoriza la participación</strong> del estudiante en las veedurías escolares
                                                            </>
                                                            )}
                                                        </span>
                                                        <span style={{color: 'red', cursor: 'pointer'}}  onClick={toggleShowMore}>
                                                            {showMore ? 'Leer menos' : 'Leer más'}
                                                        </span>
                                                        {/* <a href="#!" style={{color: 'red'}} onClick={toggleShowMore}>
                                                            {showMore ? 'Leer menos' : 'Leer más'}
                                                        </a> */}
                                                    </div>

                                                </>
                                                
                                            }
                                        </div>
                                            
                                    </div>
                                
                                
                                </AccordionDetails>
                                
                                <Divider />
                                {
                                   
                                    veeduria.message !== 'ok'
                                    ?
                                        <StyledAccordionActions> 
                                            {/* <Button size="small" className={ classes.buttonStyle }
                                            style={ { position: 'left' } }
                                            color="secondary" startIcon={ <CachedIcon /> }
                                            onClick={ handleReload }
                                            >
                                                Volver a cargar
                                            </Button> */}

                                            <Button variant="contained" size="large"  className={ classes.buttonStyle }
                                            type="submit"
                                            onClick={ e => {

                                                formatos.listado.forEach(element => {
                                                    element.HABILITADO = true;
                                                });

  
                                                    dispatch( obtenerFormatos( { dni: (informacion_basica.cargo == '007' ? values.dni : padre.dni),
                                                        tipo_doc_hijo: values.tipo_doc_hijo,
                                                        region: values.region,
                                                        tipo_inst_edu: values.tipo_inst_edu,
                                                        cargo: informacion_basica.cargo,
                                                        inst_educativa: values.inst_educativa,
                                                        lista_formato: formatos.listado } ) )
                                               
                                               /*     setFieldValue( 'formato', '' )
                                                    formatos.listado.forEach(element => {
                                                        element.HABILITADO = false;
                                                    }); */

                                                console.log('Click en ENVIAR');
                                                localStorage.setItem('tipo_envio', 2);
                                                localStorage.setItem('values.region', values.region);
                                                if (handleClickValidaForm()) {
                                                    console.log('Pasó validación handleClickValidaForm');
                                                    console.log('informacion_basica.cargo: ', informacion_basica.cargo);
                                                    if (informacion_basica.cargo == '007') {
                                                        if(values.municipalidad == '')      
                                                            scrollToAnchor('ancla_municipalidad');
                                                        if(values.grado == '' ||
                                                            values.seccion == '')      
                                                            scrollToAnchor('ancla_institucion');
                                                        if(values.nacionalidad == '' ||
                                                            values.nombre == '' ||
                                                            values.apellido_paterno == '' ||
                                                            values.apellido_materno == '' ||
                                                            values.genero == '')      
                                                            scrollToAnchor('ancla_estudiante');
                                                    }
                                                    console.log('values.autorizacion: ', values.autorizacion);
                                                    if(values.autorizacion != '1') {
                                                        console.log('Debe seleccionar la autorización de registro.');
                                                        setAlert({ ...alert, open: true,
                                                        message: 'Debe seleccionar la autorización de registro.', 
                                                        vertical: 'middle',
                                                        severity: veeduria.severity });
                                                    }
                                              }  
                                             
                                             
                                                console.log('veeduria.message 01: ', veeduria.message );
                                                console.log('values.autorizacion', values.autorizacion );
                                                localStorage.setItem('handleClickValidaForm()', handleClickValidaForm());
                                                localStorage.setItem('values.autorizacion ', values.autorizacion );
                            

                            
                                                if ( handleClickValidaForm()) {
                                                    if ( values.autorizacion == '1') {
                                              formatos.listado.forEach(element => {
                                                element.HABILITADO = true;
                                            });
                                            
                                            dispatch( getPreguntasBD( 0 ) )
                                            dispatch( obtenerFormatos( { dni: (informacion_basica.cargo == '007' ? values.dni : padre.dni),
                                                                        tipo_doc_hijo: values.tipo_doc_hijo,
                                                                        region: values.region,
                                                                        tipo_inst_edu: values.tipo_inst_edu,
                                                                        cargo: informacion_basica.cargo,
                                                                        inst_educativa: values.inst_educativa,
                                                                        lista_formato: formatos.listado } ) )

                                           setexpandedFormato( false )

                                                 } // fin values.autorizacion == '1')
                                             } // fin handleClickValidaForm()
                                            
                                        }
                                        }
                                            color="secondary" startIcon={ <SendIcon /> }  >
                                                Enviar...
                                                
                                            </Button>

                                            
                                            {/* LÓGICA: VARIAS VEEDURÍAS */}
                                            {/* {
                                                isBrowser
                                                ?
                                                    <div style={{ display: 'flex', width: '100%' }}>
        
                                                        <div style={{ display: 'flex', flexGrow: 1 }}>
                                                        </div>
                                                        <div style={{ display: 'inline-flex', flex: "0 0 auto" }}>
                                                            <Button variant="contained" size="large"
                                                            type="submit" style={{ marginRight: '15px' }}
                                                            onClick={ e => {
                                                                localStorage.setItem('tipo_envio', 1);
                                                                if (handleClickValidaForm()) {
                                                                    if(values.municipalidad == '')      
                                                                        scrollToAnchor('ancla_municipalidad');
                                                                    if(values.grado == '' ||
                                                                        values.seccion == '')      
                                                                        scrollToAnchor('ancla_institucion');
                                                                    if(values.nacionalidad == '' ||
                                                                        values.nombre == '' ||
                                                                        values.apellido_paterno == '' ||
                                                                        values.apellido_materno == '' ||
                                                                        values.genero == '')      
                                                                        scrollToAnchor('ancla_estudiante');

                                                                    if(values.autorizacion != '1') {
                                                                        console.log('Debe seleccionar la autorización de registro.');
                                                                        setAlert({ ...alert, open: true,
                                                                        message: 'Debe seleccionar la autorización de registro.', 
                                                                        vertical: 'middle',
                                                                        severity: veeduria.severity });
                                                                    }
                                                                }
                                                            } }
                                                            color="primary" startIcon={ <SendIcon /> } >
                                                                Enviar y Registrar otra veeduría
                                                            </Button>
        
        
                                                            <Button variant="contained" size="large"  className={ classes.buttonStyle }
                                                            type="submit"
                                                            onClick={ e => {
                                                                localStorage.setItem('tipo_envio', 2);
                                                                if (handleClickValidaForm()) {
                                                                    if(values.municipalidad == '')      
                                                                        scrollToAnchor('ancla_municipalidad');
                                                                    if(values.grado == '' ||
                                                                        values.seccion == '')      
                                                                        scrollToAnchor('ancla_institucion');
                                                                    if(values.nacionalidad == '' ||
                                                                        values.nombre == '' ||
                                                                        values.apellido_paterno == '' ||
                                                                        values.apellido_materno == '' ||
                                                                        values.genero == '')      
                                                                        scrollToAnchor('ancla_estudiante');

                                                                    if(values.autorizacion != '1') {
                                                                        console.log('Debe seleccionar la autorización de registro.');
                                                                        setAlert({ ...alert, open: true,
                                                                        message: 'Debe seleccionar la autorización de registro.', 
                                                                        vertical: 'middle',
                                                                        severity: veeduria.severity });
                                                                    }
                                                                }
                                                            } }
                                                            color="secondary" startIcon={ <SendIcon /> } >
                                                                Enviar y Cerrar
                                                            </Button>
                                                        </div>
                                                    </div>
                                                :
                                                    <div style={{ width: '100%' }}>
                                                        <Button variant="contained" size="large"
                                                        type="submit" style={{ width: '100%', marginBottom: '10px' }}
                                                        onClick={ e => {
                                                            localStorage.setItem('tipo_envio', 1);
                                                            if (handleClickValidaForm()) {
                                                                if(values.municipalidad == '')      
                                                                    scrollToAnchor('ancla_municipalidad');
                                                                if(values.grado == '' ||
                                                                    values.seccion == '')      
                                                                    scrollToAnchor('ancla_institucion');
                                                                if(values.nacionalidad == '' ||
                                                                    values.nombre == '' ||
                                                                    values.apellido_paterno == '' ||
                                                                    values.apellido_materno == '' ||
                                                                    values.genero == '')      
                                                                    scrollToAnchor('ancla_estudiante');
                                                            }
                                                        } }
                                                        color="primary" >
                                                            Enviar y Registrar otra veeduría
                                                        </Button>

                                                        
                                                        <Button variant="contained" size="large"  className={ classes.buttonStyle }
                                                            type="submit" style={{ width: '100%', marginBottom: '10px' }}
                                                            onClick={ e => {
                                                                localStorage.setItem('tipo_envio', 2);
                                                                if (handleClickValidaForm()) {
                                                                    if(values.municipalidad == '')      
                                                                        scrollToAnchor('ancla_municipalidad');
                                                                    if(values.grado == '' ||
                                                                        values.seccion == '')      
                                                                        scrollToAnchor('ancla_institucion');
                                                                    if(values.nacionalidad == '' ||
                                                                        values.nombre == '' ||
                                                                        values.apellido_paterno == '' ||
                                                                        values.apellido_materno == '' ||
                                                                        values.genero == '')      
                                                                        scrollToAnchor('ancla_estudiante');
                                                                }
                                                            } }
                                                            color="secondary" >
                                                                Enviar y Cerrar
                                                            </Button>
                                                    </div>
                                            } */}
                                            {/* LÓGICA: VARIAS VEEDURÍAS */}



                                        </StyledAccordionActions>
                                    : null
                                }
                                <ConfirmControl
                                    classes={{
                                        paper: classes.paper,
                                    }}
                                    id="confirmControl"
                                    keepMounted
                                    open={ openResetForm }
                                   // onSubmit={ handleSubmit }
                                    onSubmit={ handleReload }
                                   // onClose={ handleClickCloseResetForm } 
                                    onClose={ handleClickOpenResetForm } 
                                    dni={ values.dni }
                                    
                                    nombre={ `${values.nombre} ${values.apellido_paterno} ${values.apellido_materno}` } />
                                {/* <Alerta state={ alert } handleClose={ handleCloseAlert }/> */}
                                                     
                                
                 
                          
                     
                               
                             {  veeduria.message == 'ok' ?  
                                (
                               <
                              
                               SuccessDialogAndDownload
                                classes={{
                                    paper: classes.paper,
                                }}
                                id="download"
                                keepMounted
                                open={openX}
                               // open={false}
                                onClose={handleCloseX}
                                //onClose={handleReload}
                                value={valueX}
                                onSubmit={ handleReload }
                                />
                             
                         ) : (
                                
                                null
                                 
                            )

                            
                         
} 
   
                                
                            </Accordion>
                        }
                    </div>
                    {/* Fin: Formato */}


                    
                    
                </form>
            )
            
            

            } 
        </Formik>
    )
}
